/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as NewPasswordImport } from './routes/new-password'
import { Route as LoginImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth/route'
import { Route as IndexImport } from './routes/index'
import { Route as AuthUsersRouteImport } from './routes/_auth/users/route'
import { Route as AuthTimetableRouteImport } from './routes/_auth/timetable/route'
import { Route as AuthStudentsAndClassesRouteImport } from './routes/_auth/students-and-classes/route'
import { Route as AuthSectionsRouteImport } from './routes/_auth/sections/route'
import { Route as AuthSchoolSettingsRouteImport } from './routes/_auth/school-settings/route'
import { Route as AuthRoomsRouteImport } from './routes/_auth/rooms/route'
import { Route as AuthCurriculaRouteImport } from './routes/_auth/curricula/route'
import { Route as AuthCoveredAndCancelledLessonsRouteImport } from './routes/_auth/covered-and-cancelled-lessons/route'
import { Route as AuthCoursesManagementRouteImport } from './routes/_auth/courses-management/route'
import { Route as AuthCoursesRouteImport } from './routes/_auth/courses/route'
import { Route as AuthAbsencesRouteImport } from './routes/_auth/absences/route'
import { Route as AuthUsersIndexImport } from './routes/_auth/users/index'
import { Route as AuthTimetableIndexImport } from './routes/_auth/timetable/index'
import { Route as AuthStudentsAndClassesIndexImport } from './routes/_auth/students-and-classes/index'
import { Route as AuthSectionsIndexImport } from './routes/_auth/sections/index'
import { Route as AuthSchoolSettingsIndexImport } from './routes/_auth/school-settings/index'
import { Route as AuthRoomsIndexImport } from './routes/_auth/rooms/index'
import { Route as AuthCurriculaIndexImport } from './routes/_auth/curricula/index'
import { Route as AuthCoveredAndCancelledLessonsIndexImport } from './routes/_auth/covered-and-cancelled-lessons/index'
import { Route as AuthCoursesIndexImport } from './routes/_auth/courses/index'
import { Route as AuthCoursesManagementIndexImport } from './routes/_auth/courses-management/index'
import { Route as AuthAvailabilityManagementIndexImport } from './routes/_auth/availability-management/index'
import { Route as AuthAbsencesIndexImport } from './routes/_auth/absences/index'
import { Route as AuthSectionsListImport } from './routes/_auth/sections/list'
import { Route as AuthSectionsAddImport } from './routes/_auth/sections/add'
import { Route as AuthRoomsAddImport } from './routes/_auth/rooms/add'
import { Route as AuthCurriculaAddImport } from './routes/_auth/curricula/add'
import { Route as AuthCoveredAndCancelledLessonsAddCoverCancelImport } from './routes/_auth/covered-and-cancelled-lessons/add-cover-cancel'
import { Route as AuthCoursesMyCoursesImport } from './routes/_auth/courses/my-courses'
import { Route as AuthCoursesMyClassCoursesImport } from './routes/_auth/courses/my-class-courses'
import { Route as AuthCoursesAllCoursesImport } from './routes/_auth/courses/all-courses'
import { Route as AuthCoursesManagementAddImport } from './routes/_auth/courses-management/add'
import { Route as AuthAbsencesPlanImport } from './routes/_auth/absences/plan'
import { Route as AuthAbsencesAllImport } from './routes/_auth/absences/all'
import { Route as AuthAbsencesAbsencesRequestsImport } from './routes/_auth/absences/absences-requests'
import { Route as AuthUsersUserIdRouteImport } from './routes/_auth/users/$userId/route'
import { Route as AuthStudentsAndClassesStudentsRouteImport } from './routes/_auth/students-and-classes/students/route'
import { Route as AuthStudentsAndClassesClassesRouteImport } from './routes/_auth/students-and-classes/classes/route'
import { Route as AuthSchoolSettingsDayRouteImport } from './routes/_auth/school-settings/day/route'
import { Route as AuthCoveredAndCancelledLessonsCoveredRouteImport } from './routes/_auth/covered-and-cancelled-lessons/covered/route'
import { Route as AuthCoveredAndCancelledLessonsCancelledRouteImport } from './routes/_auth/covered-and-cancelled-lessons/cancelled/route'
import { Route as AuthUsersAddIndexImport } from './routes/_auth/users/add/index'
import { Route as AuthUsersUserIdIndexImport } from './routes/_auth/users/$userId/index'
import { Route as AuthStudentsAndClassesStudentsIndexImport } from './routes/_auth/students-and-classes/students/index'
import { Route as AuthStudentsAndClassesClassesIndexImport } from './routes/_auth/students-and-classes/classes/index'
import { Route as AuthSectionsSetupIndexImport } from './routes/_auth/sections/setup/index'
import { Route as AuthSectionsSectionIdIndexImport } from './routes/_auth/sections/$sectionId/index'
import { Route as AuthSchoolSettingsYearsIndexImport } from './routes/_auth/school-settings/years/index'
import { Route as AuthSchoolSettingsDayIndexImport } from './routes/_auth/school-settings/day/index'
import { Route as AuthSchoolSettingsBreaksIndexImport } from './routes/_auth/school-settings/breaks/index'
import { Route as AuthRoomsRoomIdIndexImport } from './routes/_auth/rooms/$roomId/index'
import { Route as AuthCurriculaCurriculumIdIndexImport } from './routes/_auth/curricula/$curriculumId/index'
import { Route as AuthCoursesManagementCourseIdIndexImport } from './routes/_auth/courses-management/$courseId/index'
import { Route as AuthUsersEditUserIdImport } from './routes/_auth/users/edit.$userId'
import { Route as AuthUsersUserIdDetailsImport } from './routes/_auth/users/$userId/details'
import { Route as AuthUsersUserIdCoursesImport } from './routes/_auth/users/$userId/courses'
import { Route as AuthSectionsSectionIdEditImport } from './routes/_auth/sections/$sectionId/edit'
import { Route as AuthSchoolSettingsYearsAddImport } from './routes/_auth/school-settings/years/add'
import { Route as AuthSchoolSettingsDayEditImport } from './routes/_auth/school-settings/day/edit'
import { Route as AuthSchoolSettingsBreaksAddImport } from './routes/_auth/school-settings/breaks/add'
import { Route as AuthRoomsRoomIdEditImport } from './routes/_auth/rooms/$roomId/edit'
import { Route as AuthCurriculaCurriculumIdEditImport } from './routes/_auth/curricula/$curriculumId/edit'
import { Route as AuthCoursesManagementCourseIdEditImport } from './routes/_auth/courses-management/$courseId/edit'
import { Route as AuthTimetableCourseIdGroupIdRouteImport } from './routes/_auth/timetable/$courseId.$groupId/route'
import { Route as AuthStudentsAndClassesStudentsStudentIdRouteImport } from './routes/_auth/students-and-classes/students/$studentId_/route'
import { Route as AuthStudentsAndClassesClassesClassIdRouteImport } from './routes/_auth/students-and-classes/classes/$classId_/route'
import { Route as AuthTimetableCourseIdGroupIdIndexImport } from './routes/_auth/timetable/$courseId.$groupId/index'
import { Route as AuthStudentsAndClassesStudentsAddIndexImport } from './routes/_auth/students-and-classes/students/add/index'
import { Route as AuthStudentsAndClassesClassesAddIndexImport } from './routes/_auth/students-and-classes/classes/add/index'
import { Route as AuthSchoolSettingsYearsYearIdIndexImport } from './routes/_auth/school-settings/years/$yearId/index'
import { Route as AuthSchoolSettingsBreaksBreakIdIndexImport } from './routes/_auth/school-settings/breaks/$breakId/index'
import { Route as AuthTimetableCourseIdGroupIdLessonDetailsImport } from './routes/_auth/timetable/$courseId.$groupId/lesson-details'
import { Route as AuthTimetableCourseIdGroupIdGradesImport } from './routes/_auth/timetable/$courseId.$groupId/grades'
import { Route as AuthTimetableCourseIdGroupIdCommentsImport } from './routes/_auth/timetable/$courseId.$groupId/comments'
import { Route as AuthTimetableCourseIdGroupIdAssignmentsImport } from './routes/_auth/timetable/$courseId.$groupId/assignments'
import { Route as AuthStudentsAndClassesStudentsEditStudentIdImport } from './routes/_auth/students-and-classes/students/edit.$studentId'
import { Route as AuthStudentsAndClassesStudentsStudentIdDetailsImport } from './routes/_auth/students-and-classes/students/$studentId_/details'
import { Route as AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesImport } from './routes/_auth/students-and-classes/students/$studentId_/courses-and-grades'
import { Route as AuthStudentsAndClassesStudentsStudentIdCommentsImport } from './routes/_auth/students-and-classes/students/$studentId_/comments'
import { Route as AuthStudentsAndClassesClassesEditClassIdImport } from './routes/_auth/students-and-classes/classes/edit.$classId'
import { Route as AuthStudentsAndClassesClassesClassIdGradesImport } from './routes/_auth/students-and-classes/classes/$classId_/grades'
import { Route as AuthStudentsAndClassesClassesClassIdDetailsImport } from './routes/_auth/students-and-classes/classes/$classId_/details'
import { Route as AuthStudentsAndClassesClassesClassIdCoursesAndGroupsImport } from './routes/_auth/students-and-classes/classes/$classId_/courses-and-groups'
import { Route as AuthStudentsAndClassesClassesClassIdCommentsImport } from './routes/_auth/students-and-classes/classes/$classId_/comments'
import { Route as AuthStudentsAndClassesClassesClassIdAbsencesImport } from './routes/_auth/students-and-classes/classes/$classId_/absences'
import { Route as AuthSchoolSettingsYearsYearIdEditImport } from './routes/_auth/school-settings/years/$yearId/edit'
import { Route as AuthSchoolSettingsBreaksBreakIdEditImport } from './routes/_auth/school-settings/breaks/$breakId/edit'
import { Route as AuthStudentsAndClassesStudentsParentsParentIdEditImport } from './routes/_auth/students-and-classes/students/parents.$parentId/edit'
import { Route as AuthStudentsAndClassesStudentsParentsParentIdDetailsImport } from './routes/_auth/students-and-classes/students/parents.$parentId/details'

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const NewPasswordRoute = NewPasswordImport.update({
  path: '/new-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthUsersRouteRoute = AuthUsersRouteImport.update({
  path: '/users',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthTimetableRouteRoute = AuthTimetableRouteImport.update({
  path: '/timetable',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthStudentsAndClassesRouteRoute =
  AuthStudentsAndClassesRouteImport.update({
    path: '/students-and-classes',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthSectionsRouteRoute = AuthSectionsRouteImport.update({
  path: '/sections',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSchoolSettingsRouteRoute = AuthSchoolSettingsRouteImport.update({
  path: '/school-settings',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthRoomsRouteRoute = AuthRoomsRouteImport.update({
  path: '/rooms',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCurriculaRouteRoute = AuthCurriculaRouteImport.update({
  path: '/curricula',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCoveredAndCancelledLessonsRouteRoute =
  AuthCoveredAndCancelledLessonsRouteImport.update({
    path: '/covered-and-cancelled-lessons',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthCoursesManagementRouteRoute = AuthCoursesManagementRouteImport.update(
  {
    path: '/courses-management',
    getParentRoute: () => AuthRouteRoute,
  } as any,
)

const AuthCoursesRouteRoute = AuthCoursesRouteImport.update({
  path: '/courses',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthAbsencesRouteRoute = AuthAbsencesRouteImport.update({
  path: '/absences',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthUsersIndexRoute = AuthUsersIndexImport.update({
  path: '/',
  getParentRoute: () => AuthUsersRouteRoute,
} as any)

const AuthTimetableIndexRoute = AuthTimetableIndexImport.update({
  path: '/',
  getParentRoute: () => AuthTimetableRouteRoute,
} as any)

const AuthStudentsAndClassesIndexRoute =
  AuthStudentsAndClassesIndexImport.update({
    path: '/',
    getParentRoute: () => AuthStudentsAndClassesRouteRoute,
  } as any)

const AuthSectionsIndexRoute = AuthSectionsIndexImport.update({
  path: '/',
  getParentRoute: () => AuthSectionsRouteRoute,
} as any)

const AuthSchoolSettingsIndexRoute = AuthSchoolSettingsIndexImport.update({
  path: '/',
  getParentRoute: () => AuthSchoolSettingsRouteRoute,
} as any)

const AuthRoomsIndexRoute = AuthRoomsIndexImport.update({
  path: '/',
  getParentRoute: () => AuthRoomsRouteRoute,
} as any)

const AuthCurriculaIndexRoute = AuthCurriculaIndexImport.update({
  path: '/',
  getParentRoute: () => AuthCurriculaRouteRoute,
} as any)

const AuthCoveredAndCancelledLessonsIndexRoute =
  AuthCoveredAndCancelledLessonsIndexImport.update({
    path: '/',
    getParentRoute: () => AuthCoveredAndCancelledLessonsRouteRoute,
  } as any)

const AuthCoursesIndexRoute = AuthCoursesIndexImport.update({
  path: '/',
  getParentRoute: () => AuthCoursesRouteRoute,
} as any)

const AuthCoursesManagementIndexRoute = AuthCoursesManagementIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AuthCoursesManagementRouteRoute,
  } as any,
)

const AuthAvailabilityManagementIndexRoute =
  AuthAvailabilityManagementIndexImport.update({
    path: '/availability-management/',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthAbsencesIndexRoute = AuthAbsencesIndexImport.update({
  path: '/',
  getParentRoute: () => AuthAbsencesRouteRoute,
} as any)

const AuthSectionsListRoute = AuthSectionsListImport.update({
  path: '/list',
  getParentRoute: () => AuthSectionsRouteRoute,
} as any)

const AuthSectionsAddRoute = AuthSectionsAddImport.update({
  path: '/add',
  getParentRoute: () => AuthSectionsRouteRoute,
} as any)

const AuthRoomsAddRoute = AuthRoomsAddImport.update({
  path: '/add',
  getParentRoute: () => AuthRoomsRouteRoute,
} as any)

const AuthCurriculaAddRoute = AuthCurriculaAddImport.update({
  path: '/add',
  getParentRoute: () => AuthCurriculaRouteRoute,
} as any)

const AuthCoveredAndCancelledLessonsAddCoverCancelRoute =
  AuthCoveredAndCancelledLessonsAddCoverCancelImport.update({
    path: '/add-cover-cancel',
    getParentRoute: () => AuthCoveredAndCancelledLessonsRouteRoute,
  } as any)

const AuthCoursesMyCoursesRoute = AuthCoursesMyCoursesImport.update({
  path: '/my-courses',
  getParentRoute: () => AuthCoursesRouteRoute,
} as any)

const AuthCoursesMyClassCoursesRoute = AuthCoursesMyClassCoursesImport.update({
  path: '/my-class-courses',
  getParentRoute: () => AuthCoursesRouteRoute,
} as any)

const AuthCoursesAllCoursesRoute = AuthCoursesAllCoursesImport.update({
  path: '/all-courses',
  getParentRoute: () => AuthCoursesRouteRoute,
} as any)

const AuthCoursesManagementAddRoute = AuthCoursesManagementAddImport.update({
  path: '/add',
  getParentRoute: () => AuthCoursesManagementRouteRoute,
} as any)

const AuthAbsencesPlanRoute = AuthAbsencesPlanImport.update({
  path: '/plan',
  getParentRoute: () => AuthAbsencesRouteRoute,
} as any)

const AuthAbsencesAllRoute = AuthAbsencesAllImport.update({
  path: '/all',
  getParentRoute: () => AuthAbsencesRouteRoute,
} as any)

const AuthAbsencesAbsencesRequestsRoute =
  AuthAbsencesAbsencesRequestsImport.update({
    path: '/absences-requests',
    getParentRoute: () => AuthAbsencesRouteRoute,
  } as any)

const AuthUsersUserIdRouteRoute = AuthUsersUserIdRouteImport.update({
  path: '/$userId',
  getParentRoute: () => AuthUsersRouteRoute,
} as any)

const AuthStudentsAndClassesStudentsRouteRoute =
  AuthStudentsAndClassesStudentsRouteImport.update({
    path: '/students',
    getParentRoute: () => AuthStudentsAndClassesRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesRouteRoute =
  AuthStudentsAndClassesClassesRouteImport.update({
    path: '/classes',
    getParentRoute: () => AuthStudentsAndClassesRouteRoute,
  } as any)

const AuthSchoolSettingsDayRouteRoute = AuthSchoolSettingsDayRouteImport.update(
  {
    path: '/day',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any,
)

const AuthCoveredAndCancelledLessonsCoveredRouteRoute =
  AuthCoveredAndCancelledLessonsCoveredRouteImport.update({
    path: '/covered',
    getParentRoute: () => AuthCoveredAndCancelledLessonsRouteRoute,
  } as any)

const AuthCoveredAndCancelledLessonsCancelledRouteRoute =
  AuthCoveredAndCancelledLessonsCancelledRouteImport.update({
    path: '/cancelled',
    getParentRoute: () => AuthCoveredAndCancelledLessonsRouteRoute,
  } as any)

const AuthUsersAddIndexRoute = AuthUsersAddIndexImport.update({
  path: '/add/',
  getParentRoute: () => AuthUsersRouteRoute,
} as any)

const AuthUsersUserIdIndexRoute = AuthUsersUserIdIndexImport.update({
  path: '/',
  getParentRoute: () => AuthUsersUserIdRouteRoute,
} as any)

const AuthStudentsAndClassesStudentsIndexRoute =
  AuthStudentsAndClassesStudentsIndexImport.update({
    path: '/',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesIndexRoute =
  AuthStudentsAndClassesClassesIndexImport.update({
    path: '/',
    getParentRoute: () => AuthStudentsAndClassesClassesRouteRoute,
  } as any)

const AuthSectionsSetupIndexRoute = AuthSectionsSetupIndexImport.update({
  path: '/setup/',
  getParentRoute: () => AuthSectionsRouteRoute,
} as any)

const AuthSectionsSectionIdIndexRoute = AuthSectionsSectionIdIndexImport.update(
  {
    path: '/$sectionId/',
    getParentRoute: () => AuthSectionsRouteRoute,
  } as any,
)

const AuthSchoolSettingsYearsIndexRoute =
  AuthSchoolSettingsYearsIndexImport.update({
    path: '/years/',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthSchoolSettingsDayIndexRoute = AuthSchoolSettingsDayIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AuthSchoolSettingsDayRouteRoute,
  } as any,
)

const AuthSchoolSettingsBreaksIndexRoute =
  AuthSchoolSettingsBreaksIndexImport.update({
    path: '/breaks/',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthRoomsRoomIdIndexRoute = AuthRoomsRoomIdIndexImport.update({
  path: '/$roomId/',
  getParentRoute: () => AuthRoomsRouteRoute,
} as any)

const AuthCurriculaCurriculumIdIndexRoute =
  AuthCurriculaCurriculumIdIndexImport.update({
    path: '/$curriculumId/',
    getParentRoute: () => AuthCurriculaRouteRoute,
  } as any)

const AuthCoursesManagementCourseIdIndexRoute =
  AuthCoursesManagementCourseIdIndexImport.update({
    path: '/$courseId/',
    getParentRoute: () => AuthCoursesManagementRouteRoute,
  } as any)

const AuthUsersEditUserIdRoute = AuthUsersEditUserIdImport.update({
  path: '/edit/$userId',
  getParentRoute: () => AuthUsersRouteRoute,
} as any)

const AuthUsersUserIdDetailsRoute = AuthUsersUserIdDetailsImport.update({
  path: '/details',
  getParentRoute: () => AuthUsersUserIdRouteRoute,
} as any)

const AuthUsersUserIdCoursesRoute = AuthUsersUserIdCoursesImport.update({
  path: '/courses',
  getParentRoute: () => AuthUsersUserIdRouteRoute,
} as any)

const AuthSectionsSectionIdEditRoute = AuthSectionsSectionIdEditImport.update({
  path: '/$sectionId/edit',
  getParentRoute: () => AuthSectionsRouteRoute,
} as any)

const AuthSchoolSettingsYearsAddRoute = AuthSchoolSettingsYearsAddImport.update(
  {
    path: '/years/add',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any,
)

const AuthSchoolSettingsDayEditRoute = AuthSchoolSettingsDayEditImport.update({
  path: '/edit',
  getParentRoute: () => AuthSchoolSettingsDayRouteRoute,
} as any)

const AuthSchoolSettingsBreaksAddRoute =
  AuthSchoolSettingsBreaksAddImport.update({
    path: '/breaks/add',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthRoomsRoomIdEditRoute = AuthRoomsRoomIdEditImport.update({
  path: '/$roomId/edit',
  getParentRoute: () => AuthRoomsRouteRoute,
} as any)

const AuthCurriculaCurriculumIdEditRoute =
  AuthCurriculaCurriculumIdEditImport.update({
    path: '/$curriculumId/edit',
    getParentRoute: () => AuthCurriculaRouteRoute,
  } as any)

const AuthCoursesManagementCourseIdEditRoute =
  AuthCoursesManagementCourseIdEditImport.update({
    path: '/$courseId/edit',
    getParentRoute: () => AuthCoursesManagementRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdRouteRoute =
  AuthTimetableCourseIdGroupIdRouteImport.update({
    path: '/$courseId/$groupId',
    getParentRoute: () => AuthTimetableRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsStudentIdRouteRoute =
  AuthStudentsAndClassesStudentsStudentIdRouteImport.update({
    path: '/$studentId',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdRouteRoute =
  AuthStudentsAndClassesClassesClassIdRouteImport.update({
    path: '/$classId',
    getParentRoute: () => AuthStudentsAndClassesClassesRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdIndexRoute =
  AuthTimetableCourseIdGroupIdIndexImport.update({
    path: '/',
    getParentRoute: () => AuthTimetableCourseIdGroupIdRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsAddIndexRoute =
  AuthStudentsAndClassesStudentsAddIndexImport.update({
    path: '/add/',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesAddIndexRoute =
  AuthStudentsAndClassesClassesAddIndexImport.update({
    path: '/add/',
    getParentRoute: () => AuthStudentsAndClassesClassesRouteRoute,
  } as any)

const AuthSchoolSettingsYearsYearIdIndexRoute =
  AuthSchoolSettingsYearsYearIdIndexImport.update({
    path: '/years/$yearId/',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthSchoolSettingsBreaksBreakIdIndexRoute =
  AuthSchoolSettingsBreaksBreakIdIndexImport.update({
    path: '/breaks/$breakId/',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdLessonDetailsRoute =
  AuthTimetableCourseIdGroupIdLessonDetailsImport.update({
    path: '/lesson-details',
    getParentRoute: () => AuthTimetableCourseIdGroupIdRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdGradesRoute =
  AuthTimetableCourseIdGroupIdGradesImport.update({
    path: '/grades',
    getParentRoute: () => AuthTimetableCourseIdGroupIdRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdCommentsRoute =
  AuthTimetableCourseIdGroupIdCommentsImport.update({
    path: '/comments',
    getParentRoute: () => AuthTimetableCourseIdGroupIdRouteRoute,
  } as any)

const AuthTimetableCourseIdGroupIdAssignmentsRoute =
  AuthTimetableCourseIdGroupIdAssignmentsImport.update({
    path: '/assignments',
    getParentRoute: () => AuthTimetableCourseIdGroupIdRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsEditStudentIdRoute =
  AuthStudentsAndClassesStudentsEditStudentIdImport.update({
    path: '/edit/$studentId',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsStudentIdDetailsRoute =
  AuthStudentsAndClassesStudentsStudentIdDetailsImport.update({
    path: '/details',
    getParentRoute: () => AuthStudentsAndClassesStudentsStudentIdRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute =
  AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesImport.update({
    path: '/courses-and-grades',
    getParentRoute: () => AuthStudentsAndClassesStudentsStudentIdRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsStudentIdCommentsRoute =
  AuthStudentsAndClassesStudentsStudentIdCommentsImport.update({
    path: '/comments',
    getParentRoute: () => AuthStudentsAndClassesStudentsStudentIdRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesEditClassIdRoute =
  AuthStudentsAndClassesClassesEditClassIdImport.update({
    path: '/edit/$classId',
    getParentRoute: () => AuthStudentsAndClassesClassesRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdGradesRoute =
  AuthStudentsAndClassesClassesClassIdGradesImport.update({
    path: '/grades',
    getParentRoute: () => AuthStudentsAndClassesClassesClassIdRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdDetailsRoute =
  AuthStudentsAndClassesClassesClassIdDetailsImport.update({
    path: '/details',
    getParentRoute: () => AuthStudentsAndClassesClassesClassIdRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute =
  AuthStudentsAndClassesClassesClassIdCoursesAndGroupsImport.update({
    path: '/courses-and-groups',
    getParentRoute: () => AuthStudentsAndClassesClassesClassIdRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdCommentsRoute =
  AuthStudentsAndClassesClassesClassIdCommentsImport.update({
    path: '/comments',
    getParentRoute: () => AuthStudentsAndClassesClassesClassIdRouteRoute,
  } as any)

const AuthStudentsAndClassesClassesClassIdAbsencesRoute =
  AuthStudentsAndClassesClassesClassIdAbsencesImport.update({
    path: '/absences',
    getParentRoute: () => AuthStudentsAndClassesClassesClassIdRouteRoute,
  } as any)

const AuthSchoolSettingsYearsYearIdEditRoute =
  AuthSchoolSettingsYearsYearIdEditImport.update({
    path: '/years/$yearId/edit',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthSchoolSettingsBreaksBreakIdEditRoute =
  AuthSchoolSettingsBreaksBreakIdEditImport.update({
    path: '/breaks/$breakId/edit',
    getParentRoute: () => AuthSchoolSettingsRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsParentsParentIdEditRoute =
  AuthStudentsAndClassesStudentsParentsParentIdEditImport.update({
    path: '/parents/$parentId/edit',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

const AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute =
  AuthStudentsAndClassesStudentsParentsParentIdDetailsImport.update({
    path: '/parents/$parentId/details',
    getParentRoute: () => AuthStudentsAndClassesStudentsRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/new-password': {
      id: '/new-password'
      path: '/new-password'
      fullPath: '/new-password'
      preLoaderRoute: typeof NewPasswordImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/absences': {
      id: '/_auth/absences'
      path: '/absences'
      fullPath: '/absences'
      preLoaderRoute: typeof AuthAbsencesRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/courses': {
      id: '/_auth/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AuthCoursesRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/courses-management': {
      id: '/_auth/courses-management'
      path: '/courses-management'
      fullPath: '/courses-management'
      preLoaderRoute: typeof AuthCoursesManagementRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/covered-and-cancelled-lessons': {
      id: '/_auth/covered-and-cancelled-lessons'
      path: '/covered-and-cancelled-lessons'
      fullPath: '/covered-and-cancelled-lessons'
      preLoaderRoute: typeof AuthCoveredAndCancelledLessonsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/curricula': {
      id: '/_auth/curricula'
      path: '/curricula'
      fullPath: '/curricula'
      preLoaderRoute: typeof AuthCurriculaRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/rooms': {
      id: '/_auth/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof AuthRoomsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/school-settings': {
      id: '/_auth/school-settings'
      path: '/school-settings'
      fullPath: '/school-settings'
      preLoaderRoute: typeof AuthSchoolSettingsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/sections': {
      id: '/_auth/sections'
      path: '/sections'
      fullPath: '/sections'
      preLoaderRoute: typeof AuthSectionsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/students-and-classes': {
      id: '/_auth/students-and-classes'
      path: '/students-and-classes'
      fullPath: '/students-and-classes'
      preLoaderRoute: typeof AuthStudentsAndClassesRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/timetable': {
      id: '/_auth/timetable'
      path: '/timetable'
      fullPath: '/timetable'
      preLoaderRoute: typeof AuthTimetableRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/covered-and-cancelled-lessons/cancelled': {
      id: '/_auth/covered-and-cancelled-lessons/cancelled'
      path: '/cancelled'
      fullPath: '/covered-and-cancelled-lessons/cancelled'
      preLoaderRoute: typeof AuthCoveredAndCancelledLessonsCancelledRouteImport
      parentRoute: typeof AuthCoveredAndCancelledLessonsRouteImport
    }
    '/_auth/covered-and-cancelled-lessons/covered': {
      id: '/_auth/covered-and-cancelled-lessons/covered'
      path: '/covered'
      fullPath: '/covered-and-cancelled-lessons/covered'
      preLoaderRoute: typeof AuthCoveredAndCancelledLessonsCoveredRouteImport
      parentRoute: typeof AuthCoveredAndCancelledLessonsRouteImport
    }
    '/_auth/school-settings/day': {
      id: '/_auth/school-settings/day'
      path: '/day'
      fullPath: '/school-settings/day'
      preLoaderRoute: typeof AuthSchoolSettingsDayRouteImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/students-and-classes/classes': {
      id: '/_auth/students-and-classes/classes'
      path: '/classes'
      fullPath: '/students-and-classes/classes'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesRouteImport
      parentRoute: typeof AuthStudentsAndClassesRouteImport
    }
    '/_auth/students-and-classes/students': {
      id: '/_auth/students-and-classes/students'
      path: '/students'
      fullPath: '/students-and-classes/students'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsRouteImport
      parentRoute: typeof AuthStudentsAndClassesRouteImport
    }
    '/_auth/users/$userId': {
      id: '/_auth/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthUsersUserIdRouteImport
      parentRoute: typeof AuthUsersRouteImport
    }
    '/_auth/absences/absences-requests': {
      id: '/_auth/absences/absences-requests'
      path: '/absences-requests'
      fullPath: '/absences/absences-requests'
      preLoaderRoute: typeof AuthAbsencesAbsencesRequestsImport
      parentRoute: typeof AuthAbsencesRouteImport
    }
    '/_auth/absences/all': {
      id: '/_auth/absences/all'
      path: '/all'
      fullPath: '/absences/all'
      preLoaderRoute: typeof AuthAbsencesAllImport
      parentRoute: typeof AuthAbsencesRouteImport
    }
    '/_auth/absences/plan': {
      id: '/_auth/absences/plan'
      path: '/plan'
      fullPath: '/absences/plan'
      preLoaderRoute: typeof AuthAbsencesPlanImport
      parentRoute: typeof AuthAbsencesRouteImport
    }
    '/_auth/courses-management/add': {
      id: '/_auth/courses-management/add'
      path: '/add'
      fullPath: '/courses-management/add'
      preLoaderRoute: typeof AuthCoursesManagementAddImport
      parentRoute: typeof AuthCoursesManagementRouteImport
    }
    '/_auth/courses/all-courses': {
      id: '/_auth/courses/all-courses'
      path: '/all-courses'
      fullPath: '/courses/all-courses'
      preLoaderRoute: typeof AuthCoursesAllCoursesImport
      parentRoute: typeof AuthCoursesRouteImport
    }
    '/_auth/courses/my-class-courses': {
      id: '/_auth/courses/my-class-courses'
      path: '/my-class-courses'
      fullPath: '/courses/my-class-courses'
      preLoaderRoute: typeof AuthCoursesMyClassCoursesImport
      parentRoute: typeof AuthCoursesRouteImport
    }
    '/_auth/courses/my-courses': {
      id: '/_auth/courses/my-courses'
      path: '/my-courses'
      fullPath: '/courses/my-courses'
      preLoaderRoute: typeof AuthCoursesMyCoursesImport
      parentRoute: typeof AuthCoursesRouteImport
    }
    '/_auth/covered-and-cancelled-lessons/add-cover-cancel': {
      id: '/_auth/covered-and-cancelled-lessons/add-cover-cancel'
      path: '/add-cover-cancel'
      fullPath: '/covered-and-cancelled-lessons/add-cover-cancel'
      preLoaderRoute: typeof AuthCoveredAndCancelledLessonsAddCoverCancelImport
      parentRoute: typeof AuthCoveredAndCancelledLessonsRouteImport
    }
    '/_auth/curricula/add': {
      id: '/_auth/curricula/add'
      path: '/add'
      fullPath: '/curricula/add'
      preLoaderRoute: typeof AuthCurriculaAddImport
      parentRoute: typeof AuthCurriculaRouteImport
    }
    '/_auth/rooms/add': {
      id: '/_auth/rooms/add'
      path: '/add'
      fullPath: '/rooms/add'
      preLoaderRoute: typeof AuthRoomsAddImport
      parentRoute: typeof AuthRoomsRouteImport
    }
    '/_auth/sections/add': {
      id: '/_auth/sections/add'
      path: '/add'
      fullPath: '/sections/add'
      preLoaderRoute: typeof AuthSectionsAddImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/sections/list': {
      id: '/_auth/sections/list'
      path: '/list'
      fullPath: '/sections/list'
      preLoaderRoute: typeof AuthSectionsListImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/absences/': {
      id: '/_auth/absences/'
      path: '/'
      fullPath: '/absences/'
      preLoaderRoute: typeof AuthAbsencesIndexImport
      parentRoute: typeof AuthAbsencesRouteImport
    }
    '/_auth/availability-management/': {
      id: '/_auth/availability-management/'
      path: '/availability-management'
      fullPath: '/availability-management'
      preLoaderRoute: typeof AuthAvailabilityManagementIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/courses-management/': {
      id: '/_auth/courses-management/'
      path: '/'
      fullPath: '/courses-management/'
      preLoaderRoute: typeof AuthCoursesManagementIndexImport
      parentRoute: typeof AuthCoursesManagementRouteImport
    }
    '/_auth/courses/': {
      id: '/_auth/courses/'
      path: '/'
      fullPath: '/courses/'
      preLoaderRoute: typeof AuthCoursesIndexImport
      parentRoute: typeof AuthCoursesRouteImport
    }
    '/_auth/covered-and-cancelled-lessons/': {
      id: '/_auth/covered-and-cancelled-lessons/'
      path: '/'
      fullPath: '/covered-and-cancelled-lessons/'
      preLoaderRoute: typeof AuthCoveredAndCancelledLessonsIndexImport
      parentRoute: typeof AuthCoveredAndCancelledLessonsRouteImport
    }
    '/_auth/curricula/': {
      id: '/_auth/curricula/'
      path: '/'
      fullPath: '/curricula/'
      preLoaderRoute: typeof AuthCurriculaIndexImport
      parentRoute: typeof AuthCurriculaRouteImport
    }
    '/_auth/rooms/': {
      id: '/_auth/rooms/'
      path: '/'
      fullPath: '/rooms/'
      preLoaderRoute: typeof AuthRoomsIndexImport
      parentRoute: typeof AuthRoomsRouteImport
    }
    '/_auth/school-settings/': {
      id: '/_auth/school-settings/'
      path: '/'
      fullPath: '/school-settings/'
      preLoaderRoute: typeof AuthSchoolSettingsIndexImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/sections/': {
      id: '/_auth/sections/'
      path: '/'
      fullPath: '/sections/'
      preLoaderRoute: typeof AuthSectionsIndexImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/students-and-classes/': {
      id: '/_auth/students-and-classes/'
      path: '/'
      fullPath: '/students-and-classes/'
      preLoaderRoute: typeof AuthStudentsAndClassesIndexImport
      parentRoute: typeof AuthStudentsAndClassesRouteImport
    }
    '/_auth/timetable/': {
      id: '/_auth/timetable/'
      path: '/'
      fullPath: '/timetable/'
      preLoaderRoute: typeof AuthTimetableIndexImport
      parentRoute: typeof AuthTimetableRouteImport
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexImport
      parentRoute: typeof AuthUsersRouteImport
    }
    '/_auth/students-and-classes/classes/$classId': {
      id: '/_auth/students-and-classes/classes/$classId'
      path: '/$classId'
      fullPath: '/students-and-classes/classes/$classId'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
      parentRoute: typeof AuthStudentsAndClassesClassesRouteImport
    }
    '/_auth/students-and-classes/students/$studentId': {
      id: '/_auth/students-and-classes/students/$studentId'
      path: '/$studentId'
      fullPath: '/students-and-classes/students/$studentId'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsStudentIdRouteImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
    '/_auth/timetable/$courseId/$groupId': {
      id: '/_auth/timetable/$courseId/$groupId'
      path: '/$courseId/$groupId'
      fullPath: '/timetable/$courseId/$groupId'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
      parentRoute: typeof AuthTimetableRouteImport
    }
    '/_auth/courses-management/$courseId/edit': {
      id: '/_auth/courses-management/$courseId/edit'
      path: '/$courseId/edit'
      fullPath: '/courses-management/$courseId/edit'
      preLoaderRoute: typeof AuthCoursesManagementCourseIdEditImport
      parentRoute: typeof AuthCoursesManagementRouteImport
    }
    '/_auth/curricula/$curriculumId/edit': {
      id: '/_auth/curricula/$curriculumId/edit'
      path: '/$curriculumId/edit'
      fullPath: '/curricula/$curriculumId/edit'
      preLoaderRoute: typeof AuthCurriculaCurriculumIdEditImport
      parentRoute: typeof AuthCurriculaRouteImport
    }
    '/_auth/rooms/$roomId/edit': {
      id: '/_auth/rooms/$roomId/edit'
      path: '/$roomId/edit'
      fullPath: '/rooms/$roomId/edit'
      preLoaderRoute: typeof AuthRoomsRoomIdEditImport
      parentRoute: typeof AuthRoomsRouteImport
    }
    '/_auth/school-settings/breaks/add': {
      id: '/_auth/school-settings/breaks/add'
      path: '/breaks/add'
      fullPath: '/school-settings/breaks/add'
      preLoaderRoute: typeof AuthSchoolSettingsBreaksAddImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/school-settings/day/edit': {
      id: '/_auth/school-settings/day/edit'
      path: '/edit'
      fullPath: '/school-settings/day/edit'
      preLoaderRoute: typeof AuthSchoolSettingsDayEditImport
      parentRoute: typeof AuthSchoolSettingsDayRouteImport
    }
    '/_auth/school-settings/years/add': {
      id: '/_auth/school-settings/years/add'
      path: '/years/add'
      fullPath: '/school-settings/years/add'
      preLoaderRoute: typeof AuthSchoolSettingsYearsAddImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/sections/$sectionId/edit': {
      id: '/_auth/sections/$sectionId/edit'
      path: '/$sectionId/edit'
      fullPath: '/sections/$sectionId/edit'
      preLoaderRoute: typeof AuthSectionsSectionIdEditImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/users/$userId/courses': {
      id: '/_auth/users/$userId/courses'
      path: '/courses'
      fullPath: '/users/$userId/courses'
      preLoaderRoute: typeof AuthUsersUserIdCoursesImport
      parentRoute: typeof AuthUsersUserIdRouteImport
    }
    '/_auth/users/$userId/details': {
      id: '/_auth/users/$userId/details'
      path: '/details'
      fullPath: '/users/$userId/details'
      preLoaderRoute: typeof AuthUsersUserIdDetailsImport
      parentRoute: typeof AuthUsersUserIdRouteImport
    }
    '/_auth/users/edit/$userId': {
      id: '/_auth/users/edit/$userId'
      path: '/edit/$userId'
      fullPath: '/users/edit/$userId'
      preLoaderRoute: typeof AuthUsersEditUserIdImport
      parentRoute: typeof AuthUsersRouteImport
    }
    '/_auth/courses-management/$courseId/': {
      id: '/_auth/courses-management/$courseId/'
      path: '/$courseId'
      fullPath: '/courses-management/$courseId'
      preLoaderRoute: typeof AuthCoursesManagementCourseIdIndexImport
      parentRoute: typeof AuthCoursesManagementRouteImport
    }
    '/_auth/curricula/$curriculumId/': {
      id: '/_auth/curricula/$curriculumId/'
      path: '/$curriculumId'
      fullPath: '/curricula/$curriculumId'
      preLoaderRoute: typeof AuthCurriculaCurriculumIdIndexImport
      parentRoute: typeof AuthCurriculaRouteImport
    }
    '/_auth/rooms/$roomId/': {
      id: '/_auth/rooms/$roomId/'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof AuthRoomsRoomIdIndexImport
      parentRoute: typeof AuthRoomsRouteImport
    }
    '/_auth/school-settings/breaks/': {
      id: '/_auth/school-settings/breaks/'
      path: '/breaks'
      fullPath: '/school-settings/breaks'
      preLoaderRoute: typeof AuthSchoolSettingsBreaksIndexImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/school-settings/day/': {
      id: '/_auth/school-settings/day/'
      path: '/'
      fullPath: '/school-settings/day/'
      preLoaderRoute: typeof AuthSchoolSettingsDayIndexImport
      parentRoute: typeof AuthSchoolSettingsDayRouteImport
    }
    '/_auth/school-settings/years/': {
      id: '/_auth/school-settings/years/'
      path: '/years'
      fullPath: '/school-settings/years'
      preLoaderRoute: typeof AuthSchoolSettingsYearsIndexImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/sections/$sectionId/': {
      id: '/_auth/sections/$sectionId/'
      path: '/$sectionId'
      fullPath: '/sections/$sectionId'
      preLoaderRoute: typeof AuthSectionsSectionIdIndexImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/sections/setup/': {
      id: '/_auth/sections/setup/'
      path: '/setup'
      fullPath: '/sections/setup'
      preLoaderRoute: typeof AuthSectionsSetupIndexImport
      parentRoute: typeof AuthSectionsRouteImport
    }
    '/_auth/students-and-classes/classes/': {
      id: '/_auth/students-and-classes/classes/'
      path: '/'
      fullPath: '/students-and-classes/classes/'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesIndexImport
      parentRoute: typeof AuthStudentsAndClassesClassesRouteImport
    }
    '/_auth/students-and-classes/students/': {
      id: '/_auth/students-and-classes/students/'
      path: '/'
      fullPath: '/students-and-classes/students/'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsIndexImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
    '/_auth/users/$userId/': {
      id: '/_auth/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof AuthUsersUserIdIndexImport
      parentRoute: typeof AuthUsersUserIdRouteImport
    }
    '/_auth/users/add/': {
      id: '/_auth/users/add/'
      path: '/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AuthUsersAddIndexImport
      parentRoute: typeof AuthUsersRouteImport
    }
    '/_auth/school-settings/breaks/$breakId/edit': {
      id: '/_auth/school-settings/breaks/$breakId/edit'
      path: '/breaks/$breakId/edit'
      fullPath: '/school-settings/breaks/$breakId/edit'
      preLoaderRoute: typeof AuthSchoolSettingsBreaksBreakIdEditImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/school-settings/years/$yearId/edit': {
      id: '/_auth/school-settings/years/$yearId/edit'
      path: '/years/$yearId/edit'
      fullPath: '/school-settings/years/$yearId/edit'
      preLoaderRoute: typeof AuthSchoolSettingsYearsYearIdEditImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/students-and-classes/classes/$classId/absences': {
      id: '/_auth/students-and-classes/classes/$classId/absences'
      path: '/absences'
      fullPath: '/students-and-classes/classes/$classId/absences'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdAbsencesImport
      parentRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
    }
    '/_auth/students-and-classes/classes/$classId/comments': {
      id: '/_auth/students-and-classes/classes/$classId/comments'
      path: '/comments'
      fullPath: '/students-and-classes/classes/$classId/comments'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdCommentsImport
      parentRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
    }
    '/_auth/students-and-classes/classes/$classId/courses-and-groups': {
      id: '/_auth/students-and-classes/classes/$classId/courses-and-groups'
      path: '/courses-and-groups'
      fullPath: '/students-and-classes/classes/$classId/courses-and-groups'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdCoursesAndGroupsImport
      parentRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
    }
    '/_auth/students-and-classes/classes/$classId/details': {
      id: '/_auth/students-and-classes/classes/$classId/details'
      path: '/details'
      fullPath: '/students-and-classes/classes/$classId/details'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdDetailsImport
      parentRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
    }
    '/_auth/students-and-classes/classes/$classId/grades': {
      id: '/_auth/students-and-classes/classes/$classId/grades'
      path: '/grades'
      fullPath: '/students-and-classes/classes/$classId/grades'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesClassIdGradesImport
      parentRoute: typeof AuthStudentsAndClassesClassesClassIdRouteImport
    }
    '/_auth/students-and-classes/classes/edit/$classId': {
      id: '/_auth/students-and-classes/classes/edit/$classId'
      path: '/edit/$classId'
      fullPath: '/students-and-classes/classes/edit/$classId'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesEditClassIdImport
      parentRoute: typeof AuthStudentsAndClassesClassesRouteImport
    }
    '/_auth/students-and-classes/students/$studentId/comments': {
      id: '/_auth/students-and-classes/students/$studentId/comments'
      path: '/comments'
      fullPath: '/students-and-classes/students/$studentId/comments'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsStudentIdCommentsImport
      parentRoute: typeof AuthStudentsAndClassesStudentsStudentIdRouteImport
    }
    '/_auth/students-and-classes/students/$studentId/courses-and-grades': {
      id: '/_auth/students-and-classes/students/$studentId/courses-and-grades'
      path: '/courses-and-grades'
      fullPath: '/students-and-classes/students/$studentId/courses-and-grades'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesImport
      parentRoute: typeof AuthStudentsAndClassesStudentsStudentIdRouteImport
    }
    '/_auth/students-and-classes/students/$studentId/details': {
      id: '/_auth/students-and-classes/students/$studentId/details'
      path: '/details'
      fullPath: '/students-and-classes/students/$studentId/details'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsStudentIdDetailsImport
      parentRoute: typeof AuthStudentsAndClassesStudentsStudentIdRouteImport
    }
    '/_auth/students-and-classes/students/edit/$studentId': {
      id: '/_auth/students-and-classes/students/edit/$studentId'
      path: '/edit/$studentId'
      fullPath: '/students-and-classes/students/edit/$studentId'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsEditStudentIdImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
    '/_auth/timetable/$courseId/$groupId/assignments': {
      id: '/_auth/timetable/$courseId/$groupId/assignments'
      path: '/assignments'
      fullPath: '/timetable/$courseId/$groupId/assignments'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdAssignmentsImport
      parentRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
    }
    '/_auth/timetable/$courseId/$groupId/comments': {
      id: '/_auth/timetable/$courseId/$groupId/comments'
      path: '/comments'
      fullPath: '/timetable/$courseId/$groupId/comments'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdCommentsImport
      parentRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
    }
    '/_auth/timetable/$courseId/$groupId/grades': {
      id: '/_auth/timetable/$courseId/$groupId/grades'
      path: '/grades'
      fullPath: '/timetable/$courseId/$groupId/grades'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdGradesImport
      parentRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
    }
    '/_auth/timetable/$courseId/$groupId/lesson-details': {
      id: '/_auth/timetable/$courseId/$groupId/lesson-details'
      path: '/lesson-details'
      fullPath: '/timetable/$courseId/$groupId/lesson-details'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdLessonDetailsImport
      parentRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
    }
    '/_auth/school-settings/breaks/$breakId/': {
      id: '/_auth/school-settings/breaks/$breakId/'
      path: '/breaks/$breakId'
      fullPath: '/school-settings/breaks/$breakId'
      preLoaderRoute: typeof AuthSchoolSettingsBreaksBreakIdIndexImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/school-settings/years/$yearId/': {
      id: '/_auth/school-settings/years/$yearId/'
      path: '/years/$yearId'
      fullPath: '/school-settings/years/$yearId'
      preLoaderRoute: typeof AuthSchoolSettingsYearsYearIdIndexImport
      parentRoute: typeof AuthSchoolSettingsRouteImport
    }
    '/_auth/students-and-classes/classes/add/': {
      id: '/_auth/students-and-classes/classes/add/'
      path: '/add'
      fullPath: '/students-and-classes/classes/add'
      preLoaderRoute: typeof AuthStudentsAndClassesClassesAddIndexImport
      parentRoute: typeof AuthStudentsAndClassesClassesRouteImport
    }
    '/_auth/students-and-classes/students/add/': {
      id: '/_auth/students-and-classes/students/add/'
      path: '/add'
      fullPath: '/students-and-classes/students/add'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsAddIndexImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
    '/_auth/timetable/$courseId/$groupId/': {
      id: '/_auth/timetable/$courseId/$groupId/'
      path: '/'
      fullPath: '/timetable/$courseId/$groupId/'
      preLoaderRoute: typeof AuthTimetableCourseIdGroupIdIndexImport
      parentRoute: typeof AuthTimetableCourseIdGroupIdRouteImport
    }
    '/_auth/students-and-classes/students/parents/$parentId/details': {
      id: '/_auth/students-and-classes/students/parents/$parentId/details'
      path: '/parents/$parentId/details'
      fullPath: '/students-and-classes/students/parents/$parentId/details'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsParentsParentIdDetailsImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
    '/_auth/students-and-classes/students/parents/$parentId/edit': {
      id: '/_auth/students-and-classes/students/parents/$parentId/edit'
      path: '/parents/$parentId/edit'
      fullPath: '/students-and-classes/students/parents/$parentId/edit'
      preLoaderRoute: typeof AuthStudentsAndClassesStudentsParentsParentIdEditImport
      parentRoute: typeof AuthStudentsAndClassesStudentsRouteImport
    }
  }
}

// Create and export the route tree

interface AuthAbsencesRouteRouteChildren {
  AuthAbsencesAbsencesRequestsRoute: typeof AuthAbsencesAbsencesRequestsRoute
  AuthAbsencesAllRoute: typeof AuthAbsencesAllRoute
  AuthAbsencesPlanRoute: typeof AuthAbsencesPlanRoute
  AuthAbsencesIndexRoute: typeof AuthAbsencesIndexRoute
}

const AuthAbsencesRouteRouteChildren: AuthAbsencesRouteRouteChildren = {
  AuthAbsencesAbsencesRequestsRoute: AuthAbsencesAbsencesRequestsRoute,
  AuthAbsencesAllRoute: AuthAbsencesAllRoute,
  AuthAbsencesPlanRoute: AuthAbsencesPlanRoute,
  AuthAbsencesIndexRoute: AuthAbsencesIndexRoute,
}

const AuthAbsencesRouteRouteWithChildren =
  AuthAbsencesRouteRoute._addFileChildren(AuthAbsencesRouteRouteChildren)

interface AuthCoursesRouteRouteChildren {
  AuthCoursesAllCoursesRoute: typeof AuthCoursesAllCoursesRoute
  AuthCoursesMyClassCoursesRoute: typeof AuthCoursesMyClassCoursesRoute
  AuthCoursesMyCoursesRoute: typeof AuthCoursesMyCoursesRoute
  AuthCoursesIndexRoute: typeof AuthCoursesIndexRoute
}

const AuthCoursesRouteRouteChildren: AuthCoursesRouteRouteChildren = {
  AuthCoursesAllCoursesRoute: AuthCoursesAllCoursesRoute,
  AuthCoursesMyClassCoursesRoute: AuthCoursesMyClassCoursesRoute,
  AuthCoursesMyCoursesRoute: AuthCoursesMyCoursesRoute,
  AuthCoursesIndexRoute: AuthCoursesIndexRoute,
}

const AuthCoursesRouteRouteWithChildren =
  AuthCoursesRouteRoute._addFileChildren(AuthCoursesRouteRouteChildren)

interface AuthCoursesManagementRouteRouteChildren {
  AuthCoursesManagementAddRoute: typeof AuthCoursesManagementAddRoute
  AuthCoursesManagementIndexRoute: typeof AuthCoursesManagementIndexRoute
  AuthCoursesManagementCourseIdEditRoute: typeof AuthCoursesManagementCourseIdEditRoute
  AuthCoursesManagementCourseIdIndexRoute: typeof AuthCoursesManagementCourseIdIndexRoute
}

const AuthCoursesManagementRouteRouteChildren: AuthCoursesManagementRouteRouteChildren =
  {
    AuthCoursesManagementAddRoute: AuthCoursesManagementAddRoute,
    AuthCoursesManagementIndexRoute: AuthCoursesManagementIndexRoute,
    AuthCoursesManagementCourseIdEditRoute:
      AuthCoursesManagementCourseIdEditRoute,
    AuthCoursesManagementCourseIdIndexRoute:
      AuthCoursesManagementCourseIdIndexRoute,
  }

const AuthCoursesManagementRouteRouteWithChildren =
  AuthCoursesManagementRouteRoute._addFileChildren(
    AuthCoursesManagementRouteRouteChildren,
  )

interface AuthCoveredAndCancelledLessonsRouteRouteChildren {
  AuthCoveredAndCancelledLessonsCancelledRouteRoute: typeof AuthCoveredAndCancelledLessonsCancelledRouteRoute
  AuthCoveredAndCancelledLessonsCoveredRouteRoute: typeof AuthCoveredAndCancelledLessonsCoveredRouteRoute
  AuthCoveredAndCancelledLessonsAddCoverCancelRoute: typeof AuthCoveredAndCancelledLessonsAddCoverCancelRoute
  AuthCoveredAndCancelledLessonsIndexRoute: typeof AuthCoveredAndCancelledLessonsIndexRoute
}

const AuthCoveredAndCancelledLessonsRouteRouteChildren: AuthCoveredAndCancelledLessonsRouteRouteChildren =
  {
    AuthCoveredAndCancelledLessonsCancelledRouteRoute:
      AuthCoveredAndCancelledLessonsCancelledRouteRoute,
    AuthCoveredAndCancelledLessonsCoveredRouteRoute:
      AuthCoveredAndCancelledLessonsCoveredRouteRoute,
    AuthCoveredAndCancelledLessonsAddCoverCancelRoute:
      AuthCoveredAndCancelledLessonsAddCoverCancelRoute,
    AuthCoveredAndCancelledLessonsIndexRoute:
      AuthCoveredAndCancelledLessonsIndexRoute,
  }

const AuthCoveredAndCancelledLessonsRouteRouteWithChildren =
  AuthCoveredAndCancelledLessonsRouteRoute._addFileChildren(
    AuthCoveredAndCancelledLessonsRouteRouteChildren,
  )

interface AuthCurriculaRouteRouteChildren {
  AuthCurriculaAddRoute: typeof AuthCurriculaAddRoute
  AuthCurriculaIndexRoute: typeof AuthCurriculaIndexRoute
  AuthCurriculaCurriculumIdEditRoute: typeof AuthCurriculaCurriculumIdEditRoute
  AuthCurriculaCurriculumIdIndexRoute: typeof AuthCurriculaCurriculumIdIndexRoute
}

const AuthCurriculaRouteRouteChildren: AuthCurriculaRouteRouteChildren = {
  AuthCurriculaAddRoute: AuthCurriculaAddRoute,
  AuthCurriculaIndexRoute: AuthCurriculaIndexRoute,
  AuthCurriculaCurriculumIdEditRoute: AuthCurriculaCurriculumIdEditRoute,
  AuthCurriculaCurriculumIdIndexRoute: AuthCurriculaCurriculumIdIndexRoute,
}

const AuthCurriculaRouteRouteWithChildren =
  AuthCurriculaRouteRoute._addFileChildren(AuthCurriculaRouteRouteChildren)

interface AuthRoomsRouteRouteChildren {
  AuthRoomsAddRoute: typeof AuthRoomsAddRoute
  AuthRoomsIndexRoute: typeof AuthRoomsIndexRoute
  AuthRoomsRoomIdEditRoute: typeof AuthRoomsRoomIdEditRoute
  AuthRoomsRoomIdIndexRoute: typeof AuthRoomsRoomIdIndexRoute
}

const AuthRoomsRouteRouteChildren: AuthRoomsRouteRouteChildren = {
  AuthRoomsAddRoute: AuthRoomsAddRoute,
  AuthRoomsIndexRoute: AuthRoomsIndexRoute,
  AuthRoomsRoomIdEditRoute: AuthRoomsRoomIdEditRoute,
  AuthRoomsRoomIdIndexRoute: AuthRoomsRoomIdIndexRoute,
}

const AuthRoomsRouteRouteWithChildren = AuthRoomsRouteRoute._addFileChildren(
  AuthRoomsRouteRouteChildren,
)

interface AuthSchoolSettingsDayRouteRouteChildren {
  AuthSchoolSettingsDayEditRoute: typeof AuthSchoolSettingsDayEditRoute
  AuthSchoolSettingsDayIndexRoute: typeof AuthSchoolSettingsDayIndexRoute
}

const AuthSchoolSettingsDayRouteRouteChildren: AuthSchoolSettingsDayRouteRouteChildren =
  {
    AuthSchoolSettingsDayEditRoute: AuthSchoolSettingsDayEditRoute,
    AuthSchoolSettingsDayIndexRoute: AuthSchoolSettingsDayIndexRoute,
  }

const AuthSchoolSettingsDayRouteRouteWithChildren =
  AuthSchoolSettingsDayRouteRoute._addFileChildren(
    AuthSchoolSettingsDayRouteRouteChildren,
  )

interface AuthSchoolSettingsRouteRouteChildren {
  AuthSchoolSettingsDayRouteRoute: typeof AuthSchoolSettingsDayRouteRouteWithChildren
  AuthSchoolSettingsIndexRoute: typeof AuthSchoolSettingsIndexRoute
  AuthSchoolSettingsBreaksAddRoute: typeof AuthSchoolSettingsBreaksAddRoute
  AuthSchoolSettingsYearsAddRoute: typeof AuthSchoolSettingsYearsAddRoute
  AuthSchoolSettingsBreaksIndexRoute: typeof AuthSchoolSettingsBreaksIndexRoute
  AuthSchoolSettingsYearsIndexRoute: typeof AuthSchoolSettingsYearsIndexRoute
  AuthSchoolSettingsBreaksBreakIdEditRoute: typeof AuthSchoolSettingsBreaksBreakIdEditRoute
  AuthSchoolSettingsYearsYearIdEditRoute: typeof AuthSchoolSettingsYearsYearIdEditRoute
  AuthSchoolSettingsBreaksBreakIdIndexRoute: typeof AuthSchoolSettingsBreaksBreakIdIndexRoute
  AuthSchoolSettingsYearsYearIdIndexRoute: typeof AuthSchoolSettingsYearsYearIdIndexRoute
}

const AuthSchoolSettingsRouteRouteChildren: AuthSchoolSettingsRouteRouteChildren =
  {
    AuthSchoolSettingsDayRouteRoute:
      AuthSchoolSettingsDayRouteRouteWithChildren,
    AuthSchoolSettingsIndexRoute: AuthSchoolSettingsIndexRoute,
    AuthSchoolSettingsBreaksAddRoute: AuthSchoolSettingsBreaksAddRoute,
    AuthSchoolSettingsYearsAddRoute: AuthSchoolSettingsYearsAddRoute,
    AuthSchoolSettingsBreaksIndexRoute: AuthSchoolSettingsBreaksIndexRoute,
    AuthSchoolSettingsYearsIndexRoute: AuthSchoolSettingsYearsIndexRoute,
    AuthSchoolSettingsBreaksBreakIdEditRoute:
      AuthSchoolSettingsBreaksBreakIdEditRoute,
    AuthSchoolSettingsYearsYearIdEditRoute:
      AuthSchoolSettingsYearsYearIdEditRoute,
    AuthSchoolSettingsBreaksBreakIdIndexRoute:
      AuthSchoolSettingsBreaksBreakIdIndexRoute,
    AuthSchoolSettingsYearsYearIdIndexRoute:
      AuthSchoolSettingsYearsYearIdIndexRoute,
  }

const AuthSchoolSettingsRouteRouteWithChildren =
  AuthSchoolSettingsRouteRoute._addFileChildren(
    AuthSchoolSettingsRouteRouteChildren,
  )

interface AuthSectionsRouteRouteChildren {
  AuthSectionsAddRoute: typeof AuthSectionsAddRoute
  AuthSectionsListRoute: typeof AuthSectionsListRoute
  AuthSectionsIndexRoute: typeof AuthSectionsIndexRoute
  AuthSectionsSectionIdEditRoute: typeof AuthSectionsSectionIdEditRoute
  AuthSectionsSectionIdIndexRoute: typeof AuthSectionsSectionIdIndexRoute
  AuthSectionsSetupIndexRoute: typeof AuthSectionsSetupIndexRoute
}

const AuthSectionsRouteRouteChildren: AuthSectionsRouteRouteChildren = {
  AuthSectionsAddRoute: AuthSectionsAddRoute,
  AuthSectionsListRoute: AuthSectionsListRoute,
  AuthSectionsIndexRoute: AuthSectionsIndexRoute,
  AuthSectionsSectionIdEditRoute: AuthSectionsSectionIdEditRoute,
  AuthSectionsSectionIdIndexRoute: AuthSectionsSectionIdIndexRoute,
  AuthSectionsSetupIndexRoute: AuthSectionsSetupIndexRoute,
}

const AuthSectionsRouteRouteWithChildren =
  AuthSectionsRouteRoute._addFileChildren(AuthSectionsRouteRouteChildren)

interface AuthStudentsAndClassesClassesClassIdRouteRouteChildren {
  AuthStudentsAndClassesClassesClassIdAbsencesRoute: typeof AuthStudentsAndClassesClassesClassIdAbsencesRoute
  AuthStudentsAndClassesClassesClassIdCommentsRoute: typeof AuthStudentsAndClassesClassesClassIdCommentsRoute
  AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute: typeof AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute
  AuthStudentsAndClassesClassesClassIdDetailsRoute: typeof AuthStudentsAndClassesClassesClassIdDetailsRoute
  AuthStudentsAndClassesClassesClassIdGradesRoute: typeof AuthStudentsAndClassesClassesClassIdGradesRoute
}

const AuthStudentsAndClassesClassesClassIdRouteRouteChildren: AuthStudentsAndClassesClassesClassIdRouteRouteChildren =
  {
    AuthStudentsAndClassesClassesClassIdAbsencesRoute:
      AuthStudentsAndClassesClassesClassIdAbsencesRoute,
    AuthStudentsAndClassesClassesClassIdCommentsRoute:
      AuthStudentsAndClassesClassesClassIdCommentsRoute,
    AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute:
      AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute,
    AuthStudentsAndClassesClassesClassIdDetailsRoute:
      AuthStudentsAndClassesClassesClassIdDetailsRoute,
    AuthStudentsAndClassesClassesClassIdGradesRoute:
      AuthStudentsAndClassesClassesClassIdGradesRoute,
  }

const AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren =
  AuthStudentsAndClassesClassesClassIdRouteRoute._addFileChildren(
    AuthStudentsAndClassesClassesClassIdRouteRouteChildren,
  )

interface AuthStudentsAndClassesClassesRouteRouteChildren {
  AuthStudentsAndClassesClassesClassIdRouteRoute: typeof AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren
  AuthStudentsAndClassesClassesIndexRoute: typeof AuthStudentsAndClassesClassesIndexRoute
  AuthStudentsAndClassesClassesEditClassIdRoute: typeof AuthStudentsAndClassesClassesEditClassIdRoute
  AuthStudentsAndClassesClassesAddIndexRoute: typeof AuthStudentsAndClassesClassesAddIndexRoute
}

const AuthStudentsAndClassesClassesRouteRouteChildren: AuthStudentsAndClassesClassesRouteRouteChildren =
  {
    AuthStudentsAndClassesClassesClassIdRouteRoute:
      AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren,
    AuthStudentsAndClassesClassesIndexRoute:
      AuthStudentsAndClassesClassesIndexRoute,
    AuthStudentsAndClassesClassesEditClassIdRoute:
      AuthStudentsAndClassesClassesEditClassIdRoute,
    AuthStudentsAndClassesClassesAddIndexRoute:
      AuthStudentsAndClassesClassesAddIndexRoute,
  }

const AuthStudentsAndClassesClassesRouteRouteWithChildren =
  AuthStudentsAndClassesClassesRouteRoute._addFileChildren(
    AuthStudentsAndClassesClassesRouteRouteChildren,
  )

interface AuthStudentsAndClassesStudentsStudentIdRouteRouteChildren {
  AuthStudentsAndClassesStudentsStudentIdCommentsRoute: typeof AuthStudentsAndClassesStudentsStudentIdCommentsRoute
  AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute: typeof AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute
  AuthStudentsAndClassesStudentsStudentIdDetailsRoute: typeof AuthStudentsAndClassesStudentsStudentIdDetailsRoute
}

const AuthStudentsAndClassesStudentsStudentIdRouteRouteChildren: AuthStudentsAndClassesStudentsStudentIdRouteRouteChildren =
  {
    AuthStudentsAndClassesStudentsStudentIdCommentsRoute:
      AuthStudentsAndClassesStudentsStudentIdCommentsRoute,
    AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute:
      AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute,
    AuthStudentsAndClassesStudentsStudentIdDetailsRoute:
      AuthStudentsAndClassesStudentsStudentIdDetailsRoute,
  }

const AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren =
  AuthStudentsAndClassesStudentsStudentIdRouteRoute._addFileChildren(
    AuthStudentsAndClassesStudentsStudentIdRouteRouteChildren,
  )

interface AuthStudentsAndClassesStudentsRouteRouteChildren {
  AuthStudentsAndClassesStudentsStudentIdRouteRoute: typeof AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren
  AuthStudentsAndClassesStudentsIndexRoute: typeof AuthStudentsAndClassesStudentsIndexRoute
  AuthStudentsAndClassesStudentsEditStudentIdRoute: typeof AuthStudentsAndClassesStudentsEditStudentIdRoute
  AuthStudentsAndClassesStudentsAddIndexRoute: typeof AuthStudentsAndClassesStudentsAddIndexRoute
  AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute: typeof AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute
  AuthStudentsAndClassesStudentsParentsParentIdEditRoute: typeof AuthStudentsAndClassesStudentsParentsParentIdEditRoute
}

const AuthStudentsAndClassesStudentsRouteRouteChildren: AuthStudentsAndClassesStudentsRouteRouteChildren =
  {
    AuthStudentsAndClassesStudentsStudentIdRouteRoute:
      AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren,
    AuthStudentsAndClassesStudentsIndexRoute:
      AuthStudentsAndClassesStudentsIndexRoute,
    AuthStudentsAndClassesStudentsEditStudentIdRoute:
      AuthStudentsAndClassesStudentsEditStudentIdRoute,
    AuthStudentsAndClassesStudentsAddIndexRoute:
      AuthStudentsAndClassesStudentsAddIndexRoute,
    AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute:
      AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute,
    AuthStudentsAndClassesStudentsParentsParentIdEditRoute:
      AuthStudentsAndClassesStudentsParentsParentIdEditRoute,
  }

const AuthStudentsAndClassesStudentsRouteRouteWithChildren =
  AuthStudentsAndClassesStudentsRouteRoute._addFileChildren(
    AuthStudentsAndClassesStudentsRouteRouteChildren,
  )

interface AuthStudentsAndClassesRouteRouteChildren {
  AuthStudentsAndClassesClassesRouteRoute: typeof AuthStudentsAndClassesClassesRouteRouteWithChildren
  AuthStudentsAndClassesStudentsRouteRoute: typeof AuthStudentsAndClassesStudentsRouteRouteWithChildren
  AuthStudentsAndClassesIndexRoute: typeof AuthStudentsAndClassesIndexRoute
}

const AuthStudentsAndClassesRouteRouteChildren: AuthStudentsAndClassesRouteRouteChildren =
  {
    AuthStudentsAndClassesClassesRouteRoute:
      AuthStudentsAndClassesClassesRouteRouteWithChildren,
    AuthStudentsAndClassesStudentsRouteRoute:
      AuthStudentsAndClassesStudentsRouteRouteWithChildren,
    AuthStudentsAndClassesIndexRoute: AuthStudentsAndClassesIndexRoute,
  }

const AuthStudentsAndClassesRouteRouteWithChildren =
  AuthStudentsAndClassesRouteRoute._addFileChildren(
    AuthStudentsAndClassesRouteRouteChildren,
  )

interface AuthTimetableCourseIdGroupIdRouteRouteChildren {
  AuthTimetableCourseIdGroupIdAssignmentsRoute: typeof AuthTimetableCourseIdGroupIdAssignmentsRoute
  AuthTimetableCourseIdGroupIdCommentsRoute: typeof AuthTimetableCourseIdGroupIdCommentsRoute
  AuthTimetableCourseIdGroupIdGradesRoute: typeof AuthTimetableCourseIdGroupIdGradesRoute
  AuthTimetableCourseIdGroupIdLessonDetailsRoute: typeof AuthTimetableCourseIdGroupIdLessonDetailsRoute
  AuthTimetableCourseIdGroupIdIndexRoute: typeof AuthTimetableCourseIdGroupIdIndexRoute
}

const AuthTimetableCourseIdGroupIdRouteRouteChildren: AuthTimetableCourseIdGroupIdRouteRouteChildren =
  {
    AuthTimetableCourseIdGroupIdAssignmentsRoute:
      AuthTimetableCourseIdGroupIdAssignmentsRoute,
    AuthTimetableCourseIdGroupIdCommentsRoute:
      AuthTimetableCourseIdGroupIdCommentsRoute,
    AuthTimetableCourseIdGroupIdGradesRoute:
      AuthTimetableCourseIdGroupIdGradesRoute,
    AuthTimetableCourseIdGroupIdLessonDetailsRoute:
      AuthTimetableCourseIdGroupIdLessonDetailsRoute,
    AuthTimetableCourseIdGroupIdIndexRoute:
      AuthTimetableCourseIdGroupIdIndexRoute,
  }

const AuthTimetableCourseIdGroupIdRouteRouteWithChildren =
  AuthTimetableCourseIdGroupIdRouteRoute._addFileChildren(
    AuthTimetableCourseIdGroupIdRouteRouteChildren,
  )

interface AuthTimetableRouteRouteChildren {
  AuthTimetableIndexRoute: typeof AuthTimetableIndexRoute
  AuthTimetableCourseIdGroupIdRouteRoute: typeof AuthTimetableCourseIdGroupIdRouteRouteWithChildren
}

const AuthTimetableRouteRouteChildren: AuthTimetableRouteRouteChildren = {
  AuthTimetableIndexRoute: AuthTimetableIndexRoute,
  AuthTimetableCourseIdGroupIdRouteRoute:
    AuthTimetableCourseIdGroupIdRouteRouteWithChildren,
}

const AuthTimetableRouteRouteWithChildren =
  AuthTimetableRouteRoute._addFileChildren(AuthTimetableRouteRouteChildren)

interface AuthUsersUserIdRouteRouteChildren {
  AuthUsersUserIdCoursesRoute: typeof AuthUsersUserIdCoursesRoute
  AuthUsersUserIdDetailsRoute: typeof AuthUsersUserIdDetailsRoute
  AuthUsersUserIdIndexRoute: typeof AuthUsersUserIdIndexRoute
}

const AuthUsersUserIdRouteRouteChildren: AuthUsersUserIdRouteRouteChildren = {
  AuthUsersUserIdCoursesRoute: AuthUsersUserIdCoursesRoute,
  AuthUsersUserIdDetailsRoute: AuthUsersUserIdDetailsRoute,
  AuthUsersUserIdIndexRoute: AuthUsersUserIdIndexRoute,
}

const AuthUsersUserIdRouteRouteWithChildren =
  AuthUsersUserIdRouteRoute._addFileChildren(AuthUsersUserIdRouteRouteChildren)

interface AuthUsersRouteRouteChildren {
  AuthUsersUserIdRouteRoute: typeof AuthUsersUserIdRouteRouteWithChildren
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthUsersEditUserIdRoute: typeof AuthUsersEditUserIdRoute
  AuthUsersAddIndexRoute: typeof AuthUsersAddIndexRoute
}

const AuthUsersRouteRouteChildren: AuthUsersRouteRouteChildren = {
  AuthUsersUserIdRouteRoute: AuthUsersUserIdRouteRouteWithChildren,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthUsersEditUserIdRoute: AuthUsersEditUserIdRoute,
  AuthUsersAddIndexRoute: AuthUsersAddIndexRoute,
}

const AuthUsersRouteRouteWithChildren = AuthUsersRouteRoute._addFileChildren(
  AuthUsersRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthAbsencesRouteRoute: typeof AuthAbsencesRouteRouteWithChildren
  AuthCoursesRouteRoute: typeof AuthCoursesRouteRouteWithChildren
  AuthCoursesManagementRouteRoute: typeof AuthCoursesManagementRouteRouteWithChildren
  AuthCoveredAndCancelledLessonsRouteRoute: typeof AuthCoveredAndCancelledLessonsRouteRouteWithChildren
  AuthCurriculaRouteRoute: typeof AuthCurriculaRouteRouteWithChildren
  AuthRoomsRouteRoute: typeof AuthRoomsRouteRouteWithChildren
  AuthSchoolSettingsRouteRoute: typeof AuthSchoolSettingsRouteRouteWithChildren
  AuthSectionsRouteRoute: typeof AuthSectionsRouteRouteWithChildren
  AuthStudentsAndClassesRouteRoute: typeof AuthStudentsAndClassesRouteRouteWithChildren
  AuthTimetableRouteRoute: typeof AuthTimetableRouteRouteWithChildren
  AuthUsersRouteRoute: typeof AuthUsersRouteRouteWithChildren
  AuthAvailabilityManagementIndexRoute: typeof AuthAvailabilityManagementIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAbsencesRouteRoute: AuthAbsencesRouteRouteWithChildren,
  AuthCoursesRouteRoute: AuthCoursesRouteRouteWithChildren,
  AuthCoursesManagementRouteRoute: AuthCoursesManagementRouteRouteWithChildren,
  AuthCoveredAndCancelledLessonsRouteRoute:
    AuthCoveredAndCancelledLessonsRouteRouteWithChildren,
  AuthCurriculaRouteRoute: AuthCurriculaRouteRouteWithChildren,
  AuthRoomsRouteRoute: AuthRoomsRouteRouteWithChildren,
  AuthSchoolSettingsRouteRoute: AuthSchoolSettingsRouteRouteWithChildren,
  AuthSectionsRouteRoute: AuthSectionsRouteRouteWithChildren,
  AuthStudentsAndClassesRouteRoute:
    AuthStudentsAndClassesRouteRouteWithChildren,
  AuthTimetableRouteRoute: AuthTimetableRouteRouteWithChildren,
  AuthUsersRouteRoute: AuthUsersRouteRouteWithChildren,
  AuthAvailabilityManagementIndexRoute: AuthAvailabilityManagementIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/absences': typeof AuthAbsencesRouteRouteWithChildren
  '/courses': typeof AuthCoursesRouteRouteWithChildren
  '/courses-management': typeof AuthCoursesManagementRouteRouteWithChildren
  '/covered-and-cancelled-lessons': typeof AuthCoveredAndCancelledLessonsRouteRouteWithChildren
  '/curricula': typeof AuthCurriculaRouteRouteWithChildren
  '/rooms': typeof AuthRoomsRouteRouteWithChildren
  '/school-settings': typeof AuthSchoolSettingsRouteRouteWithChildren
  '/sections': typeof AuthSectionsRouteRouteWithChildren
  '/students-and-classes': typeof AuthStudentsAndClassesRouteRouteWithChildren
  '/timetable': typeof AuthTimetableRouteRouteWithChildren
  '/users': typeof AuthUsersRouteRouteWithChildren
  '/covered-and-cancelled-lessons/cancelled': typeof AuthCoveredAndCancelledLessonsCancelledRouteRoute
  '/covered-and-cancelled-lessons/covered': typeof AuthCoveredAndCancelledLessonsCoveredRouteRoute
  '/school-settings/day': typeof AuthSchoolSettingsDayRouteRouteWithChildren
  '/students-and-classes/classes': typeof AuthStudentsAndClassesClassesRouteRouteWithChildren
  '/students-and-classes/students': typeof AuthStudentsAndClassesStudentsRouteRouteWithChildren
  '/users/$userId': typeof AuthUsersUserIdRouteRouteWithChildren
  '/absences/absences-requests': typeof AuthAbsencesAbsencesRequestsRoute
  '/absences/all': typeof AuthAbsencesAllRoute
  '/absences/plan': typeof AuthAbsencesPlanRoute
  '/courses-management/add': typeof AuthCoursesManagementAddRoute
  '/courses/all-courses': typeof AuthCoursesAllCoursesRoute
  '/courses/my-class-courses': typeof AuthCoursesMyClassCoursesRoute
  '/courses/my-courses': typeof AuthCoursesMyCoursesRoute
  '/covered-and-cancelled-lessons/add-cover-cancel': typeof AuthCoveredAndCancelledLessonsAddCoverCancelRoute
  '/curricula/add': typeof AuthCurriculaAddRoute
  '/rooms/add': typeof AuthRoomsAddRoute
  '/sections/add': typeof AuthSectionsAddRoute
  '/sections/list': typeof AuthSectionsListRoute
  '/absences/': typeof AuthAbsencesIndexRoute
  '/availability-management': typeof AuthAvailabilityManagementIndexRoute
  '/courses-management/': typeof AuthCoursesManagementIndexRoute
  '/courses/': typeof AuthCoursesIndexRoute
  '/covered-and-cancelled-lessons/': typeof AuthCoveredAndCancelledLessonsIndexRoute
  '/curricula/': typeof AuthCurriculaIndexRoute
  '/rooms/': typeof AuthRoomsIndexRoute
  '/school-settings/': typeof AuthSchoolSettingsIndexRoute
  '/sections/': typeof AuthSectionsIndexRoute
  '/students-and-classes/': typeof AuthStudentsAndClassesIndexRoute
  '/timetable/': typeof AuthTimetableIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/students-and-classes/classes/$classId': typeof AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren
  '/students-and-classes/students/$studentId': typeof AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren
  '/timetable/$courseId/$groupId': typeof AuthTimetableCourseIdGroupIdRouteRouteWithChildren
  '/courses-management/$courseId/edit': typeof AuthCoursesManagementCourseIdEditRoute
  '/curricula/$curriculumId/edit': typeof AuthCurriculaCurriculumIdEditRoute
  '/rooms/$roomId/edit': typeof AuthRoomsRoomIdEditRoute
  '/school-settings/breaks/add': typeof AuthSchoolSettingsBreaksAddRoute
  '/school-settings/day/edit': typeof AuthSchoolSettingsDayEditRoute
  '/school-settings/years/add': typeof AuthSchoolSettingsYearsAddRoute
  '/sections/$sectionId/edit': typeof AuthSectionsSectionIdEditRoute
  '/users/$userId/courses': typeof AuthUsersUserIdCoursesRoute
  '/users/$userId/details': typeof AuthUsersUserIdDetailsRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdRoute
  '/courses-management/$courseId': typeof AuthCoursesManagementCourseIdIndexRoute
  '/curricula/$curriculumId': typeof AuthCurriculaCurriculumIdIndexRoute
  '/rooms/$roomId': typeof AuthRoomsRoomIdIndexRoute
  '/school-settings/breaks': typeof AuthSchoolSettingsBreaksIndexRoute
  '/school-settings/day/': typeof AuthSchoolSettingsDayIndexRoute
  '/school-settings/years': typeof AuthSchoolSettingsYearsIndexRoute
  '/sections/$sectionId': typeof AuthSectionsSectionIdIndexRoute
  '/sections/setup': typeof AuthSectionsSetupIndexRoute
  '/students-and-classes/classes/': typeof AuthStudentsAndClassesClassesIndexRoute
  '/students-and-classes/students/': typeof AuthStudentsAndClassesStudentsIndexRoute
  '/users/$userId/': typeof AuthUsersUserIdIndexRoute
  '/users/add': typeof AuthUsersAddIndexRoute
  '/school-settings/breaks/$breakId/edit': typeof AuthSchoolSettingsBreaksBreakIdEditRoute
  '/school-settings/years/$yearId/edit': typeof AuthSchoolSettingsYearsYearIdEditRoute
  '/students-and-classes/classes/$classId/absences': typeof AuthStudentsAndClassesClassesClassIdAbsencesRoute
  '/students-and-classes/classes/$classId/comments': typeof AuthStudentsAndClassesClassesClassIdCommentsRoute
  '/students-and-classes/classes/$classId/courses-and-groups': typeof AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute
  '/students-and-classes/classes/$classId/details': typeof AuthStudentsAndClassesClassesClassIdDetailsRoute
  '/students-and-classes/classes/$classId/grades': typeof AuthStudentsAndClassesClassesClassIdGradesRoute
  '/students-and-classes/classes/edit/$classId': typeof AuthStudentsAndClassesClassesEditClassIdRoute
  '/students-and-classes/students/$studentId/comments': typeof AuthStudentsAndClassesStudentsStudentIdCommentsRoute
  '/students-and-classes/students/$studentId/courses-and-grades': typeof AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute
  '/students-and-classes/students/$studentId/details': typeof AuthStudentsAndClassesStudentsStudentIdDetailsRoute
  '/students-and-classes/students/edit/$studentId': typeof AuthStudentsAndClassesStudentsEditStudentIdRoute
  '/timetable/$courseId/$groupId/assignments': typeof AuthTimetableCourseIdGroupIdAssignmentsRoute
  '/timetable/$courseId/$groupId/comments': typeof AuthTimetableCourseIdGroupIdCommentsRoute
  '/timetable/$courseId/$groupId/grades': typeof AuthTimetableCourseIdGroupIdGradesRoute
  '/timetable/$courseId/$groupId/lesson-details': typeof AuthTimetableCourseIdGroupIdLessonDetailsRoute
  '/school-settings/breaks/$breakId': typeof AuthSchoolSettingsBreaksBreakIdIndexRoute
  '/school-settings/years/$yearId': typeof AuthSchoolSettingsYearsYearIdIndexRoute
  '/students-and-classes/classes/add': typeof AuthStudentsAndClassesClassesAddIndexRoute
  '/students-and-classes/students/add': typeof AuthStudentsAndClassesStudentsAddIndexRoute
  '/timetable/$courseId/$groupId/': typeof AuthTimetableCourseIdGroupIdIndexRoute
  '/students-and-classes/students/parents/$parentId/details': typeof AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute
  '/students-and-classes/students/parents/$parentId/edit': typeof AuthStudentsAndClassesStudentsParentsParentIdEditRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/covered-and-cancelled-lessons/cancelled': typeof AuthCoveredAndCancelledLessonsCancelledRouteRoute
  '/covered-and-cancelled-lessons/covered': typeof AuthCoveredAndCancelledLessonsCoveredRouteRoute
  '/absences/absences-requests': typeof AuthAbsencesAbsencesRequestsRoute
  '/absences/all': typeof AuthAbsencesAllRoute
  '/absences/plan': typeof AuthAbsencesPlanRoute
  '/courses-management/add': typeof AuthCoursesManagementAddRoute
  '/courses/all-courses': typeof AuthCoursesAllCoursesRoute
  '/courses/my-class-courses': typeof AuthCoursesMyClassCoursesRoute
  '/courses/my-courses': typeof AuthCoursesMyCoursesRoute
  '/covered-and-cancelled-lessons/add-cover-cancel': typeof AuthCoveredAndCancelledLessonsAddCoverCancelRoute
  '/curricula/add': typeof AuthCurriculaAddRoute
  '/rooms/add': typeof AuthRoomsAddRoute
  '/sections/add': typeof AuthSectionsAddRoute
  '/sections/list': typeof AuthSectionsListRoute
  '/absences': typeof AuthAbsencesIndexRoute
  '/availability-management': typeof AuthAvailabilityManagementIndexRoute
  '/courses-management': typeof AuthCoursesManagementIndexRoute
  '/courses': typeof AuthCoursesIndexRoute
  '/covered-and-cancelled-lessons': typeof AuthCoveredAndCancelledLessonsIndexRoute
  '/curricula': typeof AuthCurriculaIndexRoute
  '/rooms': typeof AuthRoomsIndexRoute
  '/school-settings': typeof AuthSchoolSettingsIndexRoute
  '/sections': typeof AuthSectionsIndexRoute
  '/students-and-classes': typeof AuthStudentsAndClassesIndexRoute
  '/timetable': typeof AuthTimetableIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/students-and-classes/classes/$classId': typeof AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren
  '/students-and-classes/students/$studentId': typeof AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren
  '/courses-management/$courseId/edit': typeof AuthCoursesManagementCourseIdEditRoute
  '/curricula/$curriculumId/edit': typeof AuthCurriculaCurriculumIdEditRoute
  '/rooms/$roomId/edit': typeof AuthRoomsRoomIdEditRoute
  '/school-settings/breaks/add': typeof AuthSchoolSettingsBreaksAddRoute
  '/school-settings/day/edit': typeof AuthSchoolSettingsDayEditRoute
  '/school-settings/years/add': typeof AuthSchoolSettingsYearsAddRoute
  '/sections/$sectionId/edit': typeof AuthSectionsSectionIdEditRoute
  '/users/$userId/courses': typeof AuthUsersUserIdCoursesRoute
  '/users/$userId/details': typeof AuthUsersUserIdDetailsRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdRoute
  '/courses-management/$courseId': typeof AuthCoursesManagementCourseIdIndexRoute
  '/curricula/$curriculumId': typeof AuthCurriculaCurriculumIdIndexRoute
  '/rooms/$roomId': typeof AuthRoomsRoomIdIndexRoute
  '/school-settings/breaks': typeof AuthSchoolSettingsBreaksIndexRoute
  '/school-settings/day': typeof AuthSchoolSettingsDayIndexRoute
  '/school-settings/years': typeof AuthSchoolSettingsYearsIndexRoute
  '/sections/$sectionId': typeof AuthSectionsSectionIdIndexRoute
  '/sections/setup': typeof AuthSectionsSetupIndexRoute
  '/students-and-classes/classes': typeof AuthStudentsAndClassesClassesIndexRoute
  '/students-and-classes/students': typeof AuthStudentsAndClassesStudentsIndexRoute
  '/users/$userId': typeof AuthUsersUserIdIndexRoute
  '/users/add': typeof AuthUsersAddIndexRoute
  '/school-settings/breaks/$breakId/edit': typeof AuthSchoolSettingsBreaksBreakIdEditRoute
  '/school-settings/years/$yearId/edit': typeof AuthSchoolSettingsYearsYearIdEditRoute
  '/students-and-classes/classes/$classId/absences': typeof AuthStudentsAndClassesClassesClassIdAbsencesRoute
  '/students-and-classes/classes/$classId/comments': typeof AuthStudentsAndClassesClassesClassIdCommentsRoute
  '/students-and-classes/classes/$classId/courses-and-groups': typeof AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute
  '/students-and-classes/classes/$classId/details': typeof AuthStudentsAndClassesClassesClassIdDetailsRoute
  '/students-and-classes/classes/$classId/grades': typeof AuthStudentsAndClassesClassesClassIdGradesRoute
  '/students-and-classes/classes/edit/$classId': typeof AuthStudentsAndClassesClassesEditClassIdRoute
  '/students-and-classes/students/$studentId/comments': typeof AuthStudentsAndClassesStudentsStudentIdCommentsRoute
  '/students-and-classes/students/$studentId/courses-and-grades': typeof AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute
  '/students-and-classes/students/$studentId/details': typeof AuthStudentsAndClassesStudentsStudentIdDetailsRoute
  '/students-and-classes/students/edit/$studentId': typeof AuthStudentsAndClassesStudentsEditStudentIdRoute
  '/timetable/$courseId/$groupId/assignments': typeof AuthTimetableCourseIdGroupIdAssignmentsRoute
  '/timetable/$courseId/$groupId/comments': typeof AuthTimetableCourseIdGroupIdCommentsRoute
  '/timetable/$courseId/$groupId/grades': typeof AuthTimetableCourseIdGroupIdGradesRoute
  '/timetable/$courseId/$groupId/lesson-details': typeof AuthTimetableCourseIdGroupIdLessonDetailsRoute
  '/school-settings/breaks/$breakId': typeof AuthSchoolSettingsBreaksBreakIdIndexRoute
  '/school-settings/years/$yearId': typeof AuthSchoolSettingsYearsYearIdIndexRoute
  '/students-and-classes/classes/add': typeof AuthStudentsAndClassesClassesAddIndexRoute
  '/students-and-classes/students/add': typeof AuthStudentsAndClassesStudentsAddIndexRoute
  '/timetable/$courseId/$groupId': typeof AuthTimetableCourseIdGroupIdIndexRoute
  '/students-and-classes/students/parents/$parentId/details': typeof AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute
  '/students-and-classes/students/parents/$parentId/edit': typeof AuthStudentsAndClassesStudentsParentsParentIdEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/absences': typeof AuthAbsencesRouteRouteWithChildren
  '/_auth/courses': typeof AuthCoursesRouteRouteWithChildren
  '/_auth/courses-management': typeof AuthCoursesManagementRouteRouteWithChildren
  '/_auth/covered-and-cancelled-lessons': typeof AuthCoveredAndCancelledLessonsRouteRouteWithChildren
  '/_auth/curricula': typeof AuthCurriculaRouteRouteWithChildren
  '/_auth/rooms': typeof AuthRoomsRouteRouteWithChildren
  '/_auth/school-settings': typeof AuthSchoolSettingsRouteRouteWithChildren
  '/_auth/sections': typeof AuthSectionsRouteRouteWithChildren
  '/_auth/students-and-classes': typeof AuthStudentsAndClassesRouteRouteWithChildren
  '/_auth/timetable': typeof AuthTimetableRouteRouteWithChildren
  '/_auth/users': typeof AuthUsersRouteRouteWithChildren
  '/_auth/covered-and-cancelled-lessons/cancelled': typeof AuthCoveredAndCancelledLessonsCancelledRouteRoute
  '/_auth/covered-and-cancelled-lessons/covered': typeof AuthCoveredAndCancelledLessonsCoveredRouteRoute
  '/_auth/school-settings/day': typeof AuthSchoolSettingsDayRouteRouteWithChildren
  '/_auth/students-and-classes/classes': typeof AuthStudentsAndClassesClassesRouteRouteWithChildren
  '/_auth/students-and-classes/students': typeof AuthStudentsAndClassesStudentsRouteRouteWithChildren
  '/_auth/users/$userId': typeof AuthUsersUserIdRouteRouteWithChildren
  '/_auth/absences/absences-requests': typeof AuthAbsencesAbsencesRequestsRoute
  '/_auth/absences/all': typeof AuthAbsencesAllRoute
  '/_auth/absences/plan': typeof AuthAbsencesPlanRoute
  '/_auth/courses-management/add': typeof AuthCoursesManagementAddRoute
  '/_auth/courses/all-courses': typeof AuthCoursesAllCoursesRoute
  '/_auth/courses/my-class-courses': typeof AuthCoursesMyClassCoursesRoute
  '/_auth/courses/my-courses': typeof AuthCoursesMyCoursesRoute
  '/_auth/covered-and-cancelled-lessons/add-cover-cancel': typeof AuthCoveredAndCancelledLessonsAddCoverCancelRoute
  '/_auth/curricula/add': typeof AuthCurriculaAddRoute
  '/_auth/rooms/add': typeof AuthRoomsAddRoute
  '/_auth/sections/add': typeof AuthSectionsAddRoute
  '/_auth/sections/list': typeof AuthSectionsListRoute
  '/_auth/absences/': typeof AuthAbsencesIndexRoute
  '/_auth/availability-management/': typeof AuthAvailabilityManagementIndexRoute
  '/_auth/courses-management/': typeof AuthCoursesManagementIndexRoute
  '/_auth/courses/': typeof AuthCoursesIndexRoute
  '/_auth/covered-and-cancelled-lessons/': typeof AuthCoveredAndCancelledLessonsIndexRoute
  '/_auth/curricula/': typeof AuthCurriculaIndexRoute
  '/_auth/rooms/': typeof AuthRoomsIndexRoute
  '/_auth/school-settings/': typeof AuthSchoolSettingsIndexRoute
  '/_auth/sections/': typeof AuthSectionsIndexRoute
  '/_auth/students-and-classes/': typeof AuthStudentsAndClassesIndexRoute
  '/_auth/timetable/': typeof AuthTimetableIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_auth/students-and-classes/classes/$classId': typeof AuthStudentsAndClassesClassesClassIdRouteRouteWithChildren
  '/_auth/students-and-classes/students/$studentId': typeof AuthStudentsAndClassesStudentsStudentIdRouteRouteWithChildren
  '/_auth/timetable/$courseId/$groupId': typeof AuthTimetableCourseIdGroupIdRouteRouteWithChildren
  '/_auth/courses-management/$courseId/edit': typeof AuthCoursesManagementCourseIdEditRoute
  '/_auth/curricula/$curriculumId/edit': typeof AuthCurriculaCurriculumIdEditRoute
  '/_auth/rooms/$roomId/edit': typeof AuthRoomsRoomIdEditRoute
  '/_auth/school-settings/breaks/add': typeof AuthSchoolSettingsBreaksAddRoute
  '/_auth/school-settings/day/edit': typeof AuthSchoolSettingsDayEditRoute
  '/_auth/school-settings/years/add': typeof AuthSchoolSettingsYearsAddRoute
  '/_auth/sections/$sectionId/edit': typeof AuthSectionsSectionIdEditRoute
  '/_auth/users/$userId/courses': typeof AuthUsersUserIdCoursesRoute
  '/_auth/users/$userId/details': typeof AuthUsersUserIdDetailsRoute
  '/_auth/users/edit/$userId': typeof AuthUsersEditUserIdRoute
  '/_auth/courses-management/$courseId/': typeof AuthCoursesManagementCourseIdIndexRoute
  '/_auth/curricula/$curriculumId/': typeof AuthCurriculaCurriculumIdIndexRoute
  '/_auth/rooms/$roomId/': typeof AuthRoomsRoomIdIndexRoute
  '/_auth/school-settings/breaks/': typeof AuthSchoolSettingsBreaksIndexRoute
  '/_auth/school-settings/day/': typeof AuthSchoolSettingsDayIndexRoute
  '/_auth/school-settings/years/': typeof AuthSchoolSettingsYearsIndexRoute
  '/_auth/sections/$sectionId/': typeof AuthSectionsSectionIdIndexRoute
  '/_auth/sections/setup/': typeof AuthSectionsSetupIndexRoute
  '/_auth/students-and-classes/classes/': typeof AuthStudentsAndClassesClassesIndexRoute
  '/_auth/students-and-classes/students/': typeof AuthStudentsAndClassesStudentsIndexRoute
  '/_auth/users/$userId/': typeof AuthUsersUserIdIndexRoute
  '/_auth/users/add/': typeof AuthUsersAddIndexRoute
  '/_auth/school-settings/breaks/$breakId/edit': typeof AuthSchoolSettingsBreaksBreakIdEditRoute
  '/_auth/school-settings/years/$yearId/edit': typeof AuthSchoolSettingsYearsYearIdEditRoute
  '/_auth/students-and-classes/classes/$classId/absences': typeof AuthStudentsAndClassesClassesClassIdAbsencesRoute
  '/_auth/students-and-classes/classes/$classId/comments': typeof AuthStudentsAndClassesClassesClassIdCommentsRoute
  '/_auth/students-and-classes/classes/$classId/courses-and-groups': typeof AuthStudentsAndClassesClassesClassIdCoursesAndGroupsRoute
  '/_auth/students-and-classes/classes/$classId/details': typeof AuthStudentsAndClassesClassesClassIdDetailsRoute
  '/_auth/students-and-classes/classes/$classId/grades': typeof AuthStudentsAndClassesClassesClassIdGradesRoute
  '/_auth/students-and-classes/classes/edit/$classId': typeof AuthStudentsAndClassesClassesEditClassIdRoute
  '/_auth/students-and-classes/students/$studentId/comments': typeof AuthStudentsAndClassesStudentsStudentIdCommentsRoute
  '/_auth/students-and-classes/students/$studentId/courses-and-grades': typeof AuthStudentsAndClassesStudentsStudentIdCoursesAndGradesRoute
  '/_auth/students-and-classes/students/$studentId/details': typeof AuthStudentsAndClassesStudentsStudentIdDetailsRoute
  '/_auth/students-and-classes/students/edit/$studentId': typeof AuthStudentsAndClassesStudentsEditStudentIdRoute
  '/_auth/timetable/$courseId/$groupId/assignments': typeof AuthTimetableCourseIdGroupIdAssignmentsRoute
  '/_auth/timetable/$courseId/$groupId/comments': typeof AuthTimetableCourseIdGroupIdCommentsRoute
  '/_auth/timetable/$courseId/$groupId/grades': typeof AuthTimetableCourseIdGroupIdGradesRoute
  '/_auth/timetable/$courseId/$groupId/lesson-details': typeof AuthTimetableCourseIdGroupIdLessonDetailsRoute
  '/_auth/school-settings/breaks/$breakId/': typeof AuthSchoolSettingsBreaksBreakIdIndexRoute
  '/_auth/school-settings/years/$yearId/': typeof AuthSchoolSettingsYearsYearIdIndexRoute
  '/_auth/students-and-classes/classes/add/': typeof AuthStudentsAndClassesClassesAddIndexRoute
  '/_auth/students-and-classes/students/add/': typeof AuthStudentsAndClassesStudentsAddIndexRoute
  '/_auth/timetable/$courseId/$groupId/': typeof AuthTimetableCourseIdGroupIdIndexRoute
  '/_auth/students-and-classes/students/parents/$parentId/details': typeof AuthStudentsAndClassesStudentsParentsParentIdDetailsRoute
  '/_auth/students-and-classes/students/parents/$parentId/edit': typeof AuthStudentsAndClassesStudentsParentsParentIdEditRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/new-password'
    | '/reset-password'
    | '/absences'
    | '/courses'
    | '/courses-management'
    | '/covered-and-cancelled-lessons'
    | '/curricula'
    | '/rooms'
    | '/school-settings'
    | '/sections'
    | '/students-and-classes'
    | '/timetable'
    | '/users'
    | '/covered-and-cancelled-lessons/cancelled'
    | '/covered-and-cancelled-lessons/covered'
    | '/school-settings/day'
    | '/students-and-classes/classes'
    | '/students-and-classes/students'
    | '/users/$userId'
    | '/absences/absences-requests'
    | '/absences/all'
    | '/absences/plan'
    | '/courses-management/add'
    | '/courses/all-courses'
    | '/courses/my-class-courses'
    | '/courses/my-courses'
    | '/covered-and-cancelled-lessons/add-cover-cancel'
    | '/curricula/add'
    | '/rooms/add'
    | '/sections/add'
    | '/sections/list'
    | '/absences/'
    | '/availability-management'
    | '/courses-management/'
    | '/courses/'
    | '/covered-and-cancelled-lessons/'
    | '/curricula/'
    | '/rooms/'
    | '/school-settings/'
    | '/sections/'
    | '/students-and-classes/'
    | '/timetable/'
    | '/users/'
    | '/students-and-classes/classes/$classId'
    | '/students-and-classes/students/$studentId'
    | '/timetable/$courseId/$groupId'
    | '/courses-management/$courseId/edit'
    | '/curricula/$curriculumId/edit'
    | '/rooms/$roomId/edit'
    | '/school-settings/breaks/add'
    | '/school-settings/day/edit'
    | '/school-settings/years/add'
    | '/sections/$sectionId/edit'
    | '/users/$userId/courses'
    | '/users/$userId/details'
    | '/users/edit/$userId'
    | '/courses-management/$courseId'
    | '/curricula/$curriculumId'
    | '/rooms/$roomId'
    | '/school-settings/breaks'
    | '/school-settings/day/'
    | '/school-settings/years'
    | '/sections/$sectionId'
    | '/sections/setup'
    | '/students-and-classes/classes/'
    | '/students-and-classes/students/'
    | '/users/$userId/'
    | '/users/add'
    | '/school-settings/breaks/$breakId/edit'
    | '/school-settings/years/$yearId/edit'
    | '/students-and-classes/classes/$classId/absences'
    | '/students-and-classes/classes/$classId/comments'
    | '/students-and-classes/classes/$classId/courses-and-groups'
    | '/students-and-classes/classes/$classId/details'
    | '/students-and-classes/classes/$classId/grades'
    | '/students-and-classes/classes/edit/$classId'
    | '/students-and-classes/students/$studentId/comments'
    | '/students-and-classes/students/$studentId/courses-and-grades'
    | '/students-and-classes/students/$studentId/details'
    | '/students-and-classes/students/edit/$studentId'
    | '/timetable/$courseId/$groupId/assignments'
    | '/timetable/$courseId/$groupId/comments'
    | '/timetable/$courseId/$groupId/grades'
    | '/timetable/$courseId/$groupId/lesson-details'
    | '/school-settings/breaks/$breakId'
    | '/school-settings/years/$yearId'
    | '/students-and-classes/classes/add'
    | '/students-and-classes/students/add'
    | '/timetable/$courseId/$groupId/'
    | '/students-and-classes/students/parents/$parentId/details'
    | '/students-and-classes/students/parents/$parentId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/new-password'
    | '/reset-password'
    | '/covered-and-cancelled-lessons/cancelled'
    | '/covered-and-cancelled-lessons/covered'
    | '/absences/absences-requests'
    | '/absences/all'
    | '/absences/plan'
    | '/courses-management/add'
    | '/courses/all-courses'
    | '/courses/my-class-courses'
    | '/courses/my-courses'
    | '/covered-and-cancelled-lessons/add-cover-cancel'
    | '/curricula/add'
    | '/rooms/add'
    | '/sections/add'
    | '/sections/list'
    | '/absences'
    | '/availability-management'
    | '/courses-management'
    | '/courses'
    | '/covered-and-cancelled-lessons'
    | '/curricula'
    | '/rooms'
    | '/school-settings'
    | '/sections'
    | '/students-and-classes'
    | '/timetable'
    | '/users'
    | '/students-and-classes/classes/$classId'
    | '/students-and-classes/students/$studentId'
    | '/courses-management/$courseId/edit'
    | '/curricula/$curriculumId/edit'
    | '/rooms/$roomId/edit'
    | '/school-settings/breaks/add'
    | '/school-settings/day/edit'
    | '/school-settings/years/add'
    | '/sections/$sectionId/edit'
    | '/users/$userId/courses'
    | '/users/$userId/details'
    | '/users/edit/$userId'
    | '/courses-management/$courseId'
    | '/curricula/$curriculumId'
    | '/rooms/$roomId'
    | '/school-settings/breaks'
    | '/school-settings/day'
    | '/school-settings/years'
    | '/sections/$sectionId'
    | '/sections/setup'
    | '/students-and-classes/classes'
    | '/students-and-classes/students'
    | '/users/$userId'
    | '/users/add'
    | '/school-settings/breaks/$breakId/edit'
    | '/school-settings/years/$yearId/edit'
    | '/students-and-classes/classes/$classId/absences'
    | '/students-and-classes/classes/$classId/comments'
    | '/students-and-classes/classes/$classId/courses-and-groups'
    | '/students-and-classes/classes/$classId/details'
    | '/students-and-classes/classes/$classId/grades'
    | '/students-and-classes/classes/edit/$classId'
    | '/students-and-classes/students/$studentId/comments'
    | '/students-and-classes/students/$studentId/courses-and-grades'
    | '/students-and-classes/students/$studentId/details'
    | '/students-and-classes/students/edit/$studentId'
    | '/timetable/$courseId/$groupId/assignments'
    | '/timetable/$courseId/$groupId/comments'
    | '/timetable/$courseId/$groupId/grades'
    | '/timetable/$courseId/$groupId/lesson-details'
    | '/school-settings/breaks/$breakId'
    | '/school-settings/years/$yearId'
    | '/students-and-classes/classes/add'
    | '/students-and-classes/students/add'
    | '/timetable/$courseId/$groupId'
    | '/students-and-classes/students/parents/$parentId/details'
    | '/students-and-classes/students/parents/$parentId/edit'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/new-password'
    | '/reset-password'
    | '/_auth/absences'
    | '/_auth/courses'
    | '/_auth/courses-management'
    | '/_auth/covered-and-cancelled-lessons'
    | '/_auth/curricula'
    | '/_auth/rooms'
    | '/_auth/school-settings'
    | '/_auth/sections'
    | '/_auth/students-and-classes'
    | '/_auth/timetable'
    | '/_auth/users'
    | '/_auth/covered-and-cancelled-lessons/cancelled'
    | '/_auth/covered-and-cancelled-lessons/covered'
    | '/_auth/school-settings/day'
    | '/_auth/students-and-classes/classes'
    | '/_auth/students-and-classes/students'
    | '/_auth/users/$userId'
    | '/_auth/absences/absences-requests'
    | '/_auth/absences/all'
    | '/_auth/absences/plan'
    | '/_auth/courses-management/add'
    | '/_auth/courses/all-courses'
    | '/_auth/courses/my-class-courses'
    | '/_auth/courses/my-courses'
    | '/_auth/covered-and-cancelled-lessons/add-cover-cancel'
    | '/_auth/curricula/add'
    | '/_auth/rooms/add'
    | '/_auth/sections/add'
    | '/_auth/sections/list'
    | '/_auth/absences/'
    | '/_auth/availability-management/'
    | '/_auth/courses-management/'
    | '/_auth/courses/'
    | '/_auth/covered-and-cancelled-lessons/'
    | '/_auth/curricula/'
    | '/_auth/rooms/'
    | '/_auth/school-settings/'
    | '/_auth/sections/'
    | '/_auth/students-and-classes/'
    | '/_auth/timetable/'
    | '/_auth/users/'
    | '/_auth/students-and-classes/classes/$classId'
    | '/_auth/students-and-classes/students/$studentId'
    | '/_auth/timetable/$courseId/$groupId'
    | '/_auth/courses-management/$courseId/edit'
    | '/_auth/curricula/$curriculumId/edit'
    | '/_auth/rooms/$roomId/edit'
    | '/_auth/school-settings/breaks/add'
    | '/_auth/school-settings/day/edit'
    | '/_auth/school-settings/years/add'
    | '/_auth/sections/$sectionId/edit'
    | '/_auth/users/$userId/courses'
    | '/_auth/users/$userId/details'
    | '/_auth/users/edit/$userId'
    | '/_auth/courses-management/$courseId/'
    | '/_auth/curricula/$curriculumId/'
    | '/_auth/rooms/$roomId/'
    | '/_auth/school-settings/breaks/'
    | '/_auth/school-settings/day/'
    | '/_auth/school-settings/years/'
    | '/_auth/sections/$sectionId/'
    | '/_auth/sections/setup/'
    | '/_auth/students-and-classes/classes/'
    | '/_auth/students-and-classes/students/'
    | '/_auth/users/$userId/'
    | '/_auth/users/add/'
    | '/_auth/school-settings/breaks/$breakId/edit'
    | '/_auth/school-settings/years/$yearId/edit'
    | '/_auth/students-and-classes/classes/$classId/absences'
    | '/_auth/students-and-classes/classes/$classId/comments'
    | '/_auth/students-and-classes/classes/$classId/courses-and-groups'
    | '/_auth/students-and-classes/classes/$classId/details'
    | '/_auth/students-and-classes/classes/$classId/grades'
    | '/_auth/students-and-classes/classes/edit/$classId'
    | '/_auth/students-and-classes/students/$studentId/comments'
    | '/_auth/students-and-classes/students/$studentId/courses-and-grades'
    | '/_auth/students-and-classes/students/$studentId/details'
    | '/_auth/students-and-classes/students/edit/$studentId'
    | '/_auth/timetable/$courseId/$groupId/assignments'
    | '/_auth/timetable/$courseId/$groupId/comments'
    | '/_auth/timetable/$courseId/$groupId/grades'
    | '/_auth/timetable/$courseId/$groupId/lesson-details'
    | '/_auth/school-settings/breaks/$breakId/'
    | '/_auth/school-settings/years/$yearId/'
    | '/_auth/students-and-classes/classes/add/'
    | '/_auth/students-and-classes/students/add/'
    | '/_auth/timetable/$courseId/$groupId/'
    | '/_auth/students-and-classes/students/parents/$parentId/details'
    | '/_auth/students-and-classes/students/parents/$parentId/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  NewPasswordRoute: typeof NewPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  NewPasswordRoute: NewPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/login",
        "/new-password",
        "/reset-password"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth/route.tsx",
      "children": [
        "/_auth/absences",
        "/_auth/courses",
        "/_auth/courses-management",
        "/_auth/covered-and-cancelled-lessons",
        "/_auth/curricula",
        "/_auth/rooms",
        "/_auth/school-settings",
        "/_auth/sections",
        "/_auth/students-and-classes",
        "/_auth/timetable",
        "/_auth/users",
        "/_auth/availability-management/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/new-password": {
      "filePath": "new-password.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/_auth/absences": {
      "filePath": "_auth/absences/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/absences/absences-requests",
        "/_auth/absences/all",
        "/_auth/absences/plan",
        "/_auth/absences/"
      ]
    },
    "/_auth/courses": {
      "filePath": "_auth/courses/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/courses/all-courses",
        "/_auth/courses/my-class-courses",
        "/_auth/courses/my-courses",
        "/_auth/courses/"
      ]
    },
    "/_auth/courses-management": {
      "filePath": "_auth/courses-management/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/courses-management/add",
        "/_auth/courses-management/",
        "/_auth/courses-management/$courseId/edit",
        "/_auth/courses-management/$courseId/"
      ]
    },
    "/_auth/covered-and-cancelled-lessons": {
      "filePath": "_auth/covered-and-cancelled-lessons/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/covered-and-cancelled-lessons/cancelled",
        "/_auth/covered-and-cancelled-lessons/covered",
        "/_auth/covered-and-cancelled-lessons/add-cover-cancel",
        "/_auth/covered-and-cancelled-lessons/"
      ]
    },
    "/_auth/curricula": {
      "filePath": "_auth/curricula/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/curricula/add",
        "/_auth/curricula/",
        "/_auth/curricula/$curriculumId/edit",
        "/_auth/curricula/$curriculumId/"
      ]
    },
    "/_auth/rooms": {
      "filePath": "_auth/rooms/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/rooms/add",
        "/_auth/rooms/",
        "/_auth/rooms/$roomId/edit",
        "/_auth/rooms/$roomId/"
      ]
    },
    "/_auth/school-settings": {
      "filePath": "_auth/school-settings/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/school-settings/day",
        "/_auth/school-settings/",
        "/_auth/school-settings/breaks/add",
        "/_auth/school-settings/years/add",
        "/_auth/school-settings/breaks/",
        "/_auth/school-settings/years/",
        "/_auth/school-settings/breaks/$breakId/edit",
        "/_auth/school-settings/years/$yearId/edit",
        "/_auth/school-settings/breaks/$breakId/",
        "/_auth/school-settings/years/$yearId/"
      ]
    },
    "/_auth/sections": {
      "filePath": "_auth/sections/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/sections/add",
        "/_auth/sections/list",
        "/_auth/sections/",
        "/_auth/sections/$sectionId/edit",
        "/_auth/sections/$sectionId/",
        "/_auth/sections/setup/"
      ]
    },
    "/_auth/students-and-classes": {
      "filePath": "_auth/students-and-classes/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/students-and-classes/classes",
        "/_auth/students-and-classes/students",
        "/_auth/students-and-classes/"
      ]
    },
    "/_auth/timetable": {
      "filePath": "_auth/timetable/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/timetable/",
        "/_auth/timetable/$courseId/$groupId"
      ]
    },
    "/_auth/users": {
      "filePath": "_auth/users/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/users/$userId",
        "/_auth/users/",
        "/_auth/users/edit/$userId",
        "/_auth/users/add/"
      ]
    },
    "/_auth/covered-and-cancelled-lessons/cancelled": {
      "filePath": "_auth/covered-and-cancelled-lessons/cancelled/route.tsx",
      "parent": "/_auth/covered-and-cancelled-lessons"
    },
    "/_auth/covered-and-cancelled-lessons/covered": {
      "filePath": "_auth/covered-and-cancelled-lessons/covered/route.tsx",
      "parent": "/_auth/covered-and-cancelled-lessons"
    },
    "/_auth/school-settings/day": {
      "filePath": "_auth/school-settings/day/route.tsx",
      "parent": "/_auth/school-settings",
      "children": [
        "/_auth/school-settings/day/edit",
        "/_auth/school-settings/day/"
      ]
    },
    "/_auth/students-and-classes/classes": {
      "filePath": "_auth/students-and-classes/classes/route.tsx",
      "parent": "/_auth/students-and-classes",
      "children": [
        "/_auth/students-and-classes/classes/$classId",
        "/_auth/students-and-classes/classes/",
        "/_auth/students-and-classes/classes/edit/$classId",
        "/_auth/students-and-classes/classes/add/"
      ]
    },
    "/_auth/students-and-classes/students": {
      "filePath": "_auth/students-and-classes/students/route.tsx",
      "parent": "/_auth/students-and-classes",
      "children": [
        "/_auth/students-and-classes/students/$studentId",
        "/_auth/students-and-classes/students/",
        "/_auth/students-and-classes/students/edit/$studentId",
        "/_auth/students-and-classes/students/add/",
        "/_auth/students-and-classes/students/parents/$parentId/details",
        "/_auth/students-and-classes/students/parents/$parentId/edit"
      ]
    },
    "/_auth/users/$userId": {
      "filePath": "_auth/users/$userId/route.tsx",
      "parent": "/_auth/users",
      "children": [
        "/_auth/users/$userId/courses",
        "/_auth/users/$userId/details",
        "/_auth/users/$userId/"
      ]
    },
    "/_auth/absences/absences-requests": {
      "filePath": "_auth/absences/absences-requests.tsx",
      "parent": "/_auth/absences"
    },
    "/_auth/absences/all": {
      "filePath": "_auth/absences/all.tsx",
      "parent": "/_auth/absences"
    },
    "/_auth/absences/plan": {
      "filePath": "_auth/absences/plan.tsx",
      "parent": "/_auth/absences"
    },
    "/_auth/courses-management/add": {
      "filePath": "_auth/courses-management/add.tsx",
      "parent": "/_auth/courses-management"
    },
    "/_auth/courses/all-courses": {
      "filePath": "_auth/courses/all-courses.tsx",
      "parent": "/_auth/courses"
    },
    "/_auth/courses/my-class-courses": {
      "filePath": "_auth/courses/my-class-courses.tsx",
      "parent": "/_auth/courses"
    },
    "/_auth/courses/my-courses": {
      "filePath": "_auth/courses/my-courses.tsx",
      "parent": "/_auth/courses"
    },
    "/_auth/covered-and-cancelled-lessons/add-cover-cancel": {
      "filePath": "_auth/covered-and-cancelled-lessons/add-cover-cancel.tsx",
      "parent": "/_auth/covered-and-cancelled-lessons"
    },
    "/_auth/curricula/add": {
      "filePath": "_auth/curricula/add.tsx",
      "parent": "/_auth/curricula"
    },
    "/_auth/rooms/add": {
      "filePath": "_auth/rooms/add.tsx",
      "parent": "/_auth/rooms"
    },
    "/_auth/sections/add": {
      "filePath": "_auth/sections/add.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/sections/list": {
      "filePath": "_auth/sections/list.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/absences/": {
      "filePath": "_auth/absences/index.tsx",
      "parent": "/_auth/absences"
    },
    "/_auth/availability-management/": {
      "filePath": "_auth/availability-management/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/courses-management/": {
      "filePath": "_auth/courses-management/index.tsx",
      "parent": "/_auth/courses-management"
    },
    "/_auth/courses/": {
      "filePath": "_auth/courses/index.tsx",
      "parent": "/_auth/courses"
    },
    "/_auth/covered-and-cancelled-lessons/": {
      "filePath": "_auth/covered-and-cancelled-lessons/index.tsx",
      "parent": "/_auth/covered-and-cancelled-lessons"
    },
    "/_auth/curricula/": {
      "filePath": "_auth/curricula/index.tsx",
      "parent": "/_auth/curricula"
    },
    "/_auth/rooms/": {
      "filePath": "_auth/rooms/index.tsx",
      "parent": "/_auth/rooms"
    },
    "/_auth/school-settings/": {
      "filePath": "_auth/school-settings/index.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/sections/": {
      "filePath": "_auth/sections/index.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/students-and-classes/": {
      "filePath": "_auth/students-and-classes/index.tsx",
      "parent": "/_auth/students-and-classes"
    },
    "/_auth/timetable/": {
      "filePath": "_auth/timetable/index.tsx",
      "parent": "/_auth/timetable"
    },
    "/_auth/users/": {
      "filePath": "_auth/users/index.tsx",
      "parent": "/_auth/users"
    },
    "/_auth/students-and-classes/classes/$classId": {
      "filePath": "_auth/students-and-classes/classes/$classId_/route.tsx",
      "parent": "/_auth/students-and-classes/classes",
      "children": [
        "/_auth/students-and-classes/classes/$classId/absences",
        "/_auth/students-and-classes/classes/$classId/comments",
        "/_auth/students-and-classes/classes/$classId/courses-and-groups",
        "/_auth/students-and-classes/classes/$classId/details",
        "/_auth/students-and-classes/classes/$classId/grades"
      ]
    },
    "/_auth/students-and-classes/students/$studentId": {
      "filePath": "_auth/students-and-classes/students/$studentId_/route.tsx",
      "parent": "/_auth/students-and-classes/students",
      "children": [
        "/_auth/students-and-classes/students/$studentId/comments",
        "/_auth/students-and-classes/students/$studentId/courses-and-grades",
        "/_auth/students-and-classes/students/$studentId/details"
      ]
    },
    "/_auth/timetable/$courseId/$groupId": {
      "filePath": "_auth/timetable/$courseId.$groupId/route.tsx",
      "parent": "/_auth/timetable",
      "children": [
        "/_auth/timetable/$courseId/$groupId/assignments",
        "/_auth/timetable/$courseId/$groupId/comments",
        "/_auth/timetable/$courseId/$groupId/grades",
        "/_auth/timetable/$courseId/$groupId/lesson-details",
        "/_auth/timetable/$courseId/$groupId/"
      ]
    },
    "/_auth/courses-management/$courseId/edit": {
      "filePath": "_auth/courses-management/$courseId/edit.tsx",
      "parent": "/_auth/courses-management"
    },
    "/_auth/curricula/$curriculumId/edit": {
      "filePath": "_auth/curricula/$curriculumId/edit.tsx",
      "parent": "/_auth/curricula"
    },
    "/_auth/rooms/$roomId/edit": {
      "filePath": "_auth/rooms/$roomId/edit.tsx",
      "parent": "/_auth/rooms"
    },
    "/_auth/school-settings/breaks/add": {
      "filePath": "_auth/school-settings/breaks/add.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/school-settings/day/edit": {
      "filePath": "_auth/school-settings/day/edit.tsx",
      "parent": "/_auth/school-settings/day"
    },
    "/_auth/school-settings/years/add": {
      "filePath": "_auth/school-settings/years/add.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/sections/$sectionId/edit": {
      "filePath": "_auth/sections/$sectionId/edit.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/users/$userId/courses": {
      "filePath": "_auth/users/$userId/courses.tsx",
      "parent": "/_auth/users/$userId"
    },
    "/_auth/users/$userId/details": {
      "filePath": "_auth/users/$userId/details.tsx",
      "parent": "/_auth/users/$userId"
    },
    "/_auth/users/edit/$userId": {
      "filePath": "_auth/users/edit.$userId.tsx",
      "parent": "/_auth/users"
    },
    "/_auth/courses-management/$courseId/": {
      "filePath": "_auth/courses-management/$courseId/index.tsx",
      "parent": "/_auth/courses-management"
    },
    "/_auth/curricula/$curriculumId/": {
      "filePath": "_auth/curricula/$curriculumId/index.tsx",
      "parent": "/_auth/curricula"
    },
    "/_auth/rooms/$roomId/": {
      "filePath": "_auth/rooms/$roomId/index.tsx",
      "parent": "/_auth/rooms"
    },
    "/_auth/school-settings/breaks/": {
      "filePath": "_auth/school-settings/breaks/index.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/school-settings/day/": {
      "filePath": "_auth/school-settings/day/index.tsx",
      "parent": "/_auth/school-settings/day"
    },
    "/_auth/school-settings/years/": {
      "filePath": "_auth/school-settings/years/index.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/sections/$sectionId/": {
      "filePath": "_auth/sections/$sectionId/index.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/sections/setup/": {
      "filePath": "_auth/sections/setup/index.tsx",
      "parent": "/_auth/sections"
    },
    "/_auth/students-and-classes/classes/": {
      "filePath": "_auth/students-and-classes/classes/index.tsx",
      "parent": "/_auth/students-and-classes/classes"
    },
    "/_auth/students-and-classes/students/": {
      "filePath": "_auth/students-and-classes/students/index.tsx",
      "parent": "/_auth/students-and-classes/students"
    },
    "/_auth/users/$userId/": {
      "filePath": "_auth/users/$userId/index.tsx",
      "parent": "/_auth/users/$userId"
    },
    "/_auth/users/add/": {
      "filePath": "_auth/users/add/index.tsx",
      "parent": "/_auth/users"
    },
    "/_auth/school-settings/breaks/$breakId/edit": {
      "filePath": "_auth/school-settings/breaks/$breakId/edit.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/school-settings/years/$yearId/edit": {
      "filePath": "_auth/school-settings/years/$yearId/edit.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/students-and-classes/classes/$classId/absences": {
      "filePath": "_auth/students-and-classes/classes/$classId_/absences.tsx",
      "parent": "/_auth/students-and-classes/classes/$classId"
    },
    "/_auth/students-and-classes/classes/$classId/comments": {
      "filePath": "_auth/students-and-classes/classes/$classId_/comments.tsx",
      "parent": "/_auth/students-and-classes/classes/$classId"
    },
    "/_auth/students-and-classes/classes/$classId/courses-and-groups": {
      "filePath": "_auth/students-and-classes/classes/$classId_/courses-and-groups.tsx",
      "parent": "/_auth/students-and-classes/classes/$classId"
    },
    "/_auth/students-and-classes/classes/$classId/details": {
      "filePath": "_auth/students-and-classes/classes/$classId_/details.tsx",
      "parent": "/_auth/students-and-classes/classes/$classId"
    },
    "/_auth/students-and-classes/classes/$classId/grades": {
      "filePath": "_auth/students-and-classes/classes/$classId_/grades.tsx",
      "parent": "/_auth/students-and-classes/classes/$classId"
    },
    "/_auth/students-and-classes/classes/edit/$classId": {
      "filePath": "_auth/students-and-classes/classes/edit.$classId.tsx",
      "parent": "/_auth/students-and-classes/classes"
    },
    "/_auth/students-and-classes/students/$studentId/comments": {
      "filePath": "_auth/students-and-classes/students/$studentId_/comments.tsx",
      "parent": "/_auth/students-and-classes/students/$studentId"
    },
    "/_auth/students-and-classes/students/$studentId/courses-and-grades": {
      "filePath": "_auth/students-and-classes/students/$studentId_/courses-and-grades.tsx",
      "parent": "/_auth/students-and-classes/students/$studentId"
    },
    "/_auth/students-and-classes/students/$studentId/details": {
      "filePath": "_auth/students-and-classes/students/$studentId_/details.tsx",
      "parent": "/_auth/students-and-classes/students/$studentId"
    },
    "/_auth/students-and-classes/students/edit/$studentId": {
      "filePath": "_auth/students-and-classes/students/edit.$studentId.tsx",
      "parent": "/_auth/students-and-classes/students"
    },
    "/_auth/timetable/$courseId/$groupId/assignments": {
      "filePath": "_auth/timetable/$courseId.$groupId/assignments.tsx",
      "parent": "/_auth/timetable/$courseId/$groupId"
    },
    "/_auth/timetable/$courseId/$groupId/comments": {
      "filePath": "_auth/timetable/$courseId.$groupId/comments.tsx",
      "parent": "/_auth/timetable/$courseId/$groupId"
    },
    "/_auth/timetable/$courseId/$groupId/grades": {
      "filePath": "_auth/timetable/$courseId.$groupId/grades.tsx",
      "parent": "/_auth/timetable/$courseId/$groupId"
    },
    "/_auth/timetable/$courseId/$groupId/lesson-details": {
      "filePath": "_auth/timetable/$courseId.$groupId/lesson-details.tsx",
      "parent": "/_auth/timetable/$courseId/$groupId"
    },
    "/_auth/school-settings/breaks/$breakId/": {
      "filePath": "_auth/school-settings/breaks/$breakId/index.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/school-settings/years/$yearId/": {
      "filePath": "_auth/school-settings/years/$yearId/index.tsx",
      "parent": "/_auth/school-settings"
    },
    "/_auth/students-and-classes/classes/add/": {
      "filePath": "_auth/students-and-classes/classes/add/index.tsx",
      "parent": "/_auth/students-and-classes/classes"
    },
    "/_auth/students-and-classes/students/add/": {
      "filePath": "_auth/students-and-classes/students/add/index.tsx",
      "parent": "/_auth/students-and-classes/students"
    },
    "/_auth/timetable/$courseId/$groupId/": {
      "filePath": "_auth/timetable/$courseId.$groupId/index.tsx",
      "parent": "/_auth/timetable/$courseId/$groupId"
    },
    "/_auth/students-and-classes/students/parents/$parentId/details": {
      "filePath": "_auth/students-and-classes/students/parents.$parentId/details.tsx",
      "parent": "/_auth/students-and-classes/students"
    },
    "/_auth/students-and-classes/students/parents/$parentId/edit": {
      "filePath": "_auth/students-and-classes/students/parents.$parentId/edit.tsx",
      "parent": "/_auth/students-and-classes/students"
    }
  }
}
ROUTE_MANIFEST_END */
